export const fr = {
  app: {
    name: "Phygiatech ERP",
    shortName: "Phygiatech",
    tagline: "Gestion opérationnelle",
  },
  nav: {
    dashboard: "Tableau de bord",
    orders: "Commandes",
    quotes: "Devis",
    invoices: "Factures",
    customers: "Clients",
    products: "Produits",
    stock: "Stock",
    purchasing: "Achats",
    suppliers: "Fournisseurs",
    sav: "SAV",
    shipments: "Expéditions",
    reports: "Rapports",
    settings: "Réglages",
    help: "Aide",
    more: "Plus",
    search: "Rechercher",
    sections: {
      sales: "Ventes",
      logistics: "Logistique",
      catalog: "Catalogue",
      admin: "Administration",
    },
    collapse: "Réduire la barre latérale",
    expand: "Déployer la barre latérale",
    openMenu: "Ouvrir le menu",
  },
  common: {
    actions: {
      save: "Enregistrer",
      cancel: "Annuler",
      create: "Créer",
      edit: "Modifier",
      delete: "Supprimer",
      archive: "Archiver",
      restore: "Restaurer",
      close: "Fermer",
      confirm: "Confirmer",
      retry: "Réessayer",
      back: "Retour",
      search: "Rechercher",
      filter: "Filtrer",
      clearFilters: "Effacer les filtres",
      export: "Exporter",
      more: "Plus d'actions",
      signOut: "Se déconnecter",
      copy: "Copier",
      add: "Ajouter",
      remove: "Retirer",
      reload: "Recharger",
    },
    fields: {
      name: "Nom",
      email: "E-mail",
      phone: "Téléphone",
      notes: "Notes",
      createdAt: "Créé le",
      updatedAt: "Modifié le",
      status: "Statut",
      type: "Type",
      reference: "Référence",
      address: "Adresse",
      street: "Adresse",
      street2: "Complément",
      postalCode: "Code postal",
      city: "Ville",
      country: "Pays",
      website: "Site web",
    },
    states: {
      loading: "Chargement…",
      saving: "Enregistrement…",
      saved: "Enregistré",
      empty: "Rien à afficher pour l'instant",
      noResults: "Aucun résultat",
      noResultsHint: "Essayez d'autres termes ou retirez des filtres.",
      optional: "Facultatif",
      required: "Obligatoire",
      enabled: "Activé",
      disabled: "Désactivé",
      unknown: "Inconnu",
      none: "Aucun",
      // Feminine nouns (une date, une référence): « Date de commande : Non renseignée ».
      unset: "Non renseignée",
    },
    table: {
      rows: "{count, plural, =0 {Aucune ligne} one {# ligne} other {# lignes}}",
      selected: "{count, plural, one {# sélectionnée} other {# sélectionnées}}",
      sortAsc: "Trier par ordre croissant",
      sortDesc: "Trier par ordre décroissant",
      columns: "Colonnes",
      selectAll: "Sélectionner les lignes affichées",
      selectRow: "Sélectionner {label}",
      pagination: "Pages de la liste",
      range: "{from}–{to} sur {total}",
      page: "Page {page} / {pages}",
      previous: "Précédente",
      next: "Suivante",
    },
    confirm: {
      title: "Êtes-vous sûr ?",
      irreversible: "Cette action est irréversible.",
    },
    theme: {
      label: "Thème",
      light: "Clair",
      dark: "Sombre",
      system: "Système",
    },
    language: {
      label: "Langue",
      fr: "Français",
      en: "English",
    },
  },
  errors: {
    generic: "Une erreur inattendue est survenue.",
    network: "Connexion au serveur impossible. Vérifiez votre réseau.",
    offline: "Vous êtes hors ligne. Les données affichées peuvent ne pas être à jour.",
    unauthorized: "Votre session a expiré. Reconnectez-vous.",
    forbidden: "Vous n'avez pas les droits nécessaires pour cette action.",
    notFound: "Élément introuvable.",
    validation: "Certains champs sont invalides.",
    conflict: "Cet élément a été modifié entre-temps. Rechargez la page.",
    rateLimited: "Trop de tentatives. Réessayez dans quelques instants.",
    codes: {
      "auth.invalid_credentials": "E-mail ou mot de passe incorrect.",
      "auth.two_factor_required": "Code de vérification requis.",
      "auth.two_factor_invalid": "Code de vérification incorrect.",
      "customer.archived": "Ce client est archivé : restaurez-le avant de lui faire un document.",
      "customer.contact_not_found": "Ce contact n'existe plus pour ce client : rechargez la fiche.",
      "customer.not_found": "Client introuvable.",
      "supplier.not_found": "Fournisseur introuvable.",
      "product.archived": "{sku} est archivé : il ne peut plus être vendu.",
      "product.archive_has_stock": "{sku} a encore du stock : sortez-le ou inventoriez-le à zéro avant de l'archiver.",
      "product.archive_open_order": "{sku} reste à expédier sur la commande {order} : il ne peut pas être archivé.",
      "product.archive_in_kit": "Cet article entre dans la composition {sku} : retirez-l'en avant de l'archiver.",
      "product.not_found": "Produit introuvable.",
      "product.sku_taken": "Ce SKU est déjà utilisé.",
      "product.kit_self": "Une composition ne peut pas se contenir elle-même.",
      "product.component_is_kit": "Un composant doit être un article physique, pas une composition.",
      "product.kit_used_as_component": "Cet article entre dans une composition : il ne peut pas en devenir une.",
      "product.split_needs_two_axes":
        "Ce produit n'a pas deux options (par exemple taille du gilet et taille du cummerbund) à dissocier.",
      "product.split_inconsistent": "Les variantes de ce produit n'ont pas toutes les mêmes options.",
      "product.split_archived": "Ce produit est archivé : restaurez-le avant de dissocier ses variantes.",
      "product.already_split": "Ce produit est déjà composé d'articles.",
      "product.split_serial_tracked": "Un produit suivi par numéro de série ne peut pas devenir une composition.",
      "product.split_sku_taken": "Les références des articles à créer existent déjà.",
      "product.attach_web_variant": "Cette variante vient du site : elle reste rattachée à son produit Shopify.",
      "product.attach_same": "La variante appartient déjà à ce produit.",
      "product.attach_archived": "Ce produit est archivé : restaurez-le avant d'y rattacher une variante.",
      "product.attach_vat": "Les deux produits n'ont pas le même taux de TVA : alignez-les avant de rattacher la variante.",
      "product.attach_serial":
        "Un seul des deux produits est suivi par numéro de série : alignez-les avant de rattacher la variante.",
      "product.attach_axes": "Renseignez une valeur pour chaque option du produit choisi.",
      "product.attach_taken": "Le produit choisi a déjà une variante avec ces options.",
      "product.kit_has_stock": "Cet article a du stock : mettez-le à zéro avant d'en faire une composition.",
      "product.kit_open_orders":
        "Des commandes en cours réservent cet article : expédiez-les ou modifiez leur ligne avant de changer sa composition.",
      "invoice.not_fully_credited":
        "Cette facture n'est pas entièrement couverte par des avoirs émis : sa commande ne peut pas être refacturée.",
      "invoice.already_reinvoiced": "Les quantités de cette facture ont déjà été remises à facturer.",
      "product.kit_open_purchase":
        "Cet article est encore attendu sur une commande fournisseur : réceptionnez-la ou clôturez-la avant d'en faire une composition.",
      "variant.not_found": "Variante introuvable.",
      "import.stock_forbidden": "Stock initial et coût d'un article en stock : réservés à qui gère le stock.",
      "import.invalid_file": "Fichier illisible ou vide.",
      "import.supplier_unknown": "Fournisseur inconnu : créez-le ou importez les fournisseurs d'abord.",
      "import.component_unknown": "Composant inconnu : sa référence n'existe ni dans le catalogue ni plus haut dans le fichier.",
      "shopify.not_configured": "La connexion Shopify n'est pas configurée.",
      "shopify.request_failed": "Shopify n'a pas répondu correctement.",
      "shopify.refund_order_unknown":
        "Remboursement Shopify d'une commande que l'ERP n'a pas encore : il sera repris à son arrivée.",
      "stock_count.not_found": "Inventaire introuvable.",
      "stock_count.locked": "Cet inventaire est déjà validé ou annulé.",
      "stock_count.empty": "Saisissez au moins une quantité comptée avant de valider.",
      "stock.insufficient": "Stock insuffisant pour cette opération.",
      "stock.reserved_for_other_orders":
        "{quantity} unité(s) de {sku} sont isolées pour d'autres commandes. Confirmez pour les prendre : elles seront retirées de ces commandes.",
      "stock.kit_has_no_stock": "Une composition n'a pas de stock propre : corrigez, sortez ou inventoriez ses composants.",
      "stock.serials_required": "Cet article est suivi par numéro de série : saisissez un numéro par unité.",
      "stock.serial_unknown": "Numéro de série inconnu pour cet article.",
      "stock.serial_not_in_stock": "Ce numéro de série n'est pas en stock.",
      "stock.serial_duplicate": "Numéro de série en double.",
      "stock.serials_count_mismatch": "Le nombre de numéros de série ne correspond pas à la quantité.",
      "stock.serial_not_shipped_to_order": "Ce numéro de série n'a pas été expédié sur cette commande.",
      "stock.kit_not_serial_trackable":
        "Une composition, ou un composant de composition, ne peut pas être suivie par numéro de série.",
      "stock.serial_not_found": "Numéro de série introuvable.",
      "sav.reason_unknown": "Motif inconnu : choisissez-en un dans la liste.",
      "family.not_found": "Famille introuvable.",
      "settings.serials_mismatch":
        "Des articles suivis ont un stock sans numéros de série : affectez-les depuis leur fiche produit avant d'activer le suivi.",
      "quote.not_found": "Devis introuvable.",
      "quote.locked": "Ce devis ne peut plus être modifié.",
      "quote.external": "Ce devis vient d'IABAKO : il peut être accepté, pas modifié dans l'ERP.",
      "quote.not_sendable": "Ce devis est refusé, annulé ou expiré : il ne peut plus être envoyé.",
      "quote.empty": "Ajoutez au moins une ligne.",
      "order.not_found": "Commande introuvable.",
      "order.locked": "Cette commande ne peut plus être modifiée.",
      "order.cancelled": "Cette commande est annulée : elle ne peut plus être facturée.",
      "order.empty_selection": "Aucun article de la sélection ne reste à expédier.",
      "order.cancel_invoiced":
        "Cette commande a des factures émises : établissez d'abord un avoir sur chacune, puis annulez la commande.",
      "order.allocation_exceeds_line": "On ne peut pas réserver plus que ce qui reste à expédier sur la ligne.",
      "order.allocation_exceeds_stock":
        "Pas assez de stock libre pour réserver {sku} : le reste est déjà réservé pour d'autres commandes.",
      "order.nothing_to_invoice": "Tout a déjà été facturé sur cette commande.",
      "order.refs_locked":
        "Une facture est déjà émise sur cette commande : ses références administratives ne peuvent plus changer.",
      "order.attachment_invalid": "Fichier vide ou illisible.",
      "order.attachment_too_large":
        "Fichier trop volumineux : bon de commande et BL signé ne doivent pas dépasser 3,5 Mo à eux deux (limite du dépôt Chorus Pro).",
      "order.no_purchase_order": "Aucun bon de commande joint à cette commande.",
      "order.no_signed_delivery_note": "Aucun bon de livraison signé joint à cette commande.",
      "invoice.not_found": "Facture introuvable.",
      "invoice.locked": "Une facture émise ne peut plus être modifiée : établissez un avoir.",
      "invoice.empty": "Ajoutez au moins une ligne.",
      "invoice.not_issued": "Cette facture n'est pas encore émise.",
      "invoice.credit_exceeds": "L'avoir dépasse ce qui reste à créditer sur la facture (montant ou quantité d'une ligne).",
      "invoice.credit_note_locked":
        "Un avoir reprend la facture qu'il corrige : supprimez ce brouillon et établissez-en un autre plutôt que de le modifier.",
      "invoice.deposits_disabled": "Les factures d'acompte sont désactivées (Réglages › Devis et factures › Acomptes).",
      "invoice.deposit_locked":
        "Une facture d'acompte se recrée plutôt que de se modifier : supprimez-la et demandez-en une autre.",
      "invoice.deposit_unpaid":
        "Un acompte émis sur cette commande n'est pas encore réglé : enregistrez son paiement (ou annulez-le par un avoir) avant d'émettre la facture définitive.",
      "invoice.deposit_exceeds": "Les acomptes dépasseraient le montant de la commande.",
      "invoice.deposit_deducted": "Cet acompte a déjà été repris sur une facture définitive : il ne peut plus être annulé.",
      "invoice.deposit_partial_credit": "Un acompte s'annule en entier, pas en partie.",
      "invoice.deposit_already_invoiced": "La commande a déjà sa facture définitive : plus d'acompte possible.",
      "invoice.deposit_shopify": "Pas d'acompte sur une commande du site.",
      "invoice.buyer_address_required":
        "Une facture doit porter l'adresse du client : complétez l'adresse de facturation de la fiche client, puis recréez le brouillon.",
      "invoice.public_siret_required":
        "Une facture à un organisme public exige son SIRET (Chorus Pro ne peut pas l'acheminer sans) : complétez la fiche client, puis recréez le brouillon.",
      "invoice.deposit_after_final":
        "La commande a déjà sa facture définitive : cet acompte ne peut plus être émis. Supprimez le brouillon.",
      "invoice.deposit_draft_pending":
        "Une facture d'acompte de cette commande est encore en brouillon : émettez-la ou supprimez-la avant d'émettre la facture définitive.",
      "invoice.export_too_long": "Période trop longue : exportez au plus un an à la fois.",
      "invoice.external":
        "Ce document a été émis dans Shopify (Simple Invoice) : le PDF, les paiements et les avoirs se gèrent depuis Shopify.",
      "order.invoiced_in_shopify":
        "Les commandes du site sont facturées dans Shopify (Simple Invoice) : la facture est enregistrée ici dès que la commande est payée.",
      "payment.exceeds": "Le paiement dépasse le reste à payer.",
      "print.executable_missing":
        "L'exécutable de l'agent n'est pas disponible sur ce serveur : demandez-le à votre prestataire.",
      "print.agent_not_found": "Agent d'impression introuvable.",
      "print.job_not_found": "Impression introuvable ou déjà traitée.",
      "print.no_label": "Cette expédition n'a pas d'étiquette.",
      "print.no_route": "Aucune imprimante n'est choisie pour ce document (Réglages › Impression).",
      "print.agent_offline":
        "L'ordinateur d'impression ne répond pas : imprimez depuis le navigateur ou vérifiez que l'agent tourne.",
      "shipment.not_found": "Expédition introuvable.",
      "shipment.locked": "Cette expédition est déjà partie.",
      "shipment.empty": "Sélectionnez au moins un article à expédier.",
      "shipment.no_address": "Aucune adresse de livraison ni de facturation : complétez la fiche client ou la commande.",
      "shipment.laposte_missing_contact":
        "La Poste exige un téléphone et un e-mail pour chaque destinataire : complétez la commande ou la fiche client.",
      "shipment.exceeds_remaining": "La quantité dépasse le reste à expédier.",
      "company.logo_invalid": "Logo refusé : image PNG ou JPEG de 2 Mo maximum.",
      "company.logo_missing": "Aucun logo personnalisé.",
      "shipment.not_resendable": "Seul un colis déjà parti peut être renvoyé.",
      "shipment.not_cancellable": "Seul un envoi parti et pas encore livré peut être annulé.",
      "shipment.already_in_shopify":
        "Cet envoi est déjà enregistré dans Shopify : annulez-le d'abord dans Shopify, l'ERP suivra.",
      "shipment.cancelled": "Cette expédition est annulée.",
      "carrier.not_configured": "Le transporteur n'est pas configuré. Saisissez le numéro de suivi à la main.",
      "carrier.failed": "Le transporteur a refusé l'étiquette. Vérifiez l'adresse et le poids.",
      "carrier.label_in_transit":
        "La Poste a déjà pris ce colis en charge : son étiquette Colissimo est utilisée et ne peut plus être annulée.",
      "carrier.check_failed":
        "Le suivi Colissimo ne répond pas : impossible de vérifier que le colis n'est pas parti. Réessayez dans un moment.",
      "carrier.customs_hs_code_missing":
        "Déclaration en douane : l'article {sku} n'a pas de code SH. Renseignez-le sur sa fiche produit, ou un code par défaut dans Réglages › Société.",
      "carrier.customs_value_missing": "Déclaration en douane : l'article {sku} n'a ni prix ni valeur à déclarer.",
      "carrier.customs_weight_missing":
        "Déclaration en douane : l'article {sku} n'a pas de poids. Renseignez-le sur sa fiche produit.",
      "carrier.customs_empty": "Déclaration en douane : ce colis ne contient aucun article à déclarer.",
      "carrier.customs_return_unsupported":
        "Colissimo ne fait d'étiquette retour que vers la France métropolitaine ou Monaco : choisissez une adresse de retour en métropole (Réglages › SAV).",
      "carrier.return_invoice_missing":
        "Un retour depuis l'étranger hors Union européenne ou depuis l'outre-mer se déclare contre la facture d'origine : émettez d'abord la facture de la commande.",
      "carrier.return_parcel_missing":
        "Un retour depuis l'étranger hors Union européenne ou depuis l'outre-mer se déclare contre le colis d'origine : la commande n'a aucun colis expédié avec un numéro de suivi.",
      "carrier.return_origin_mixed":
        "Un retour international déclare un seul pays d'origine pour tous ses articles : faites une étiquette par pays d'origine.",
      "carrier.customs_multi_parcel":
        "Un envoi hors de l'Union européenne se fait colis par colis (une déclaration en douane par colis) : expédiez chaque colis séparément.",
      "email.not_configured": "L'envoi d'e-mails n'est pas configuré.",
      "email.no_recipient": "Aucune adresse e-mail pour ce destinataire.",
      "purchase.empty": "Saisissez au moins une quantité reçue.",
      "purchase.not_found": "Commande fournisseur introuvable.",
      "purchase.payment_not_found": "Ce paiement n'existe plus sur cette commande fournisseur.",
      "purchase.locked": "Cette commande fournisseur ne peut plus être modifiée.",
      "purchase.receive_draft": "Une commande brouillon ne se reçoit pas : envoyez-la ou marquez-la envoyée d'abord.",
      "purchase.not_closable": "Seule une commande dont une partie au moins est reçue peut voir sa réception clôturée.",
      "purchase.below_received": "Une quantité ne peut pas descendre sous ce qui est déjà reçu (ni un article reçu être retiré).",
      "purchase.received_locked": "Une partie est déjà reçue : le fournisseur et la devise ne changent plus.",
      "purchase.receipt_exceeds": "La quantité reçue dépasse la quantité commandée.",
      "purchase.kit_line": "Une composition ne s'achète pas : commandez ses composants.",
      "sav.not_found": "Dossier SAV introuvable.",
      "sav.exceeds_quantity": "La quantité reçue dépasse la quantité retournée.",
      "sav.duplicate_line": "Une même ligne du dossier apparaît deux fois : regroupez les quantités.",
      "sav.exceeds_order_line": "Le dossier déclare plus d'unités que la ligne de commande n'en contient.",
      "sav.exceeds_returnable":
        "Plus d'unités reviendraient du client qu'il n'en a reçu sur cette commande (dossiers précédents compris).",
      "sav.already_refunded": "Ce dossier a déjà été remboursé.",
      "sav.refund_after_replacement":
        "Ce dossier a déjà été réglé par un échange ou un remplacement. Un remboursement partiel se fait par un avoir sur la facture.",
      "sav.nothing_to_undo": "Aucune action à annuler sur ce dossier (un remboursement ne s'annule pas ici).",
      "sav.undo_received": "Le colis retour a déjà été réceptionné : annulez d'abord la réception.",
      "sav.undo_serials": "Cette réception a enregistré des numéros de série : corrigez-la depuis le stock.",
      "sav.refund_component":
        "Un article seul d'un ensemble ne se rembourse pas automatiquement : faites un avoir depuis la facture.",
      "sav.not_in_order": "Cet article ne fait pas partie de la ligne de commande choisie.",
      "sav.refund_partial_kit":
        "Shopify ne rembourse qu'un ensemble complet : remboursez ce composant seul depuis l'admin Shopify (montant libre).",
      "sav.no_invoice": "Aucune facture émise à créditer pour cette commande.",
      "sav.locked": "Ce dossier SAV est clôturé.",
      "sav.attachment_invalid": "Fichier vide ou illisible.",
      "sav.attachment_too_large": "Fichier trop volumineux (10 Mo maximum).",
      "sav.exchange_not_open":
        "L'échange s'envoie depuis un dossier ouvert. L'étiquette retour existe déjà : envoyez un remplacement.",
      "integration.not_configured": "Renseignez d'abord les champs obligatoires de cette intégration.",
      "integration.invalid_value": "Une des valeurs saisies n'est pas valide.",
      "integration.test_failed": "Le service a refusé la connexion. Vérifiez les identifiants.",
      "iabako.login_failed": "IABAKO a refusé la connexion. Vérifiez l'e-mail et le mot de passe dans Réglages › Intégrations.",
      "iabako.screen_changed": "Un écran d'IABAKO n'a pas l'aspect attendu (IABAKO a peut-être changé). Rien n'a été écrit.",
      "iabako.write_blocked": "La lecture a été arrêtée : IABAKO allait enregistrer une modification. Rien n'a été écrit.",
      "iabako.timeout": "La lecture d'IABAKO a pris trop de temps. Relancez-la.",
      "iabako.unexpected": "La lecture d'IABAKO a échoué. Rien n'a été écrit.",
      "iabako.run_not_found": "Cette lecture d'IABAKO n'existe plus.",
      "iabako.run_not_ready": "Cette lecture d'IABAKO n'est pas prête ou a déjà été appliquée.",
      "iabako.run_stale": "Cet aperçu est trop ancien : relancez la lecture d'IABAKO avant d'appliquer.",
      "iabako.apply_failed": "L'application a été refusée et entièrement annulée. Relancez la lecture d'IABAKO.",
      "iabako.mapping_invalid": "L'article ou le client choisi n'existe plus.",
      "iabako.simulation_failed": "La simulation a refusé ce lot. Rien n'a été écrit, voir le détail :",
      "chorus.not_configured": "Le raccordement Chorus Pro n'est pas configuré.",
      "chorus.request_failed": "Chorus Pro a refusé ou n'a pas traité la demande.",
      "chorus.missing_siret": "Le SIRET du client public est requis pour Chorus Pro.",
      "chorus.already_deposited": "Cette facture est déjà déposée sur Chorus Pro.",
      "chorus.in_progress": "Un dépôt de cette facture sur Chorus Pro est en cours : attendez son résultat.",
      "inqom.not_configured": "Le raccordement à l'API Inqom n'est pas configuré.",
      "inqom.request_failed": "Inqom a refusé ou n'a pas traité la demande.",
      "inqom.already_deposited": "Ce document est déjà déposé chez Inqom.",
      "invoice.export_empty": "Aucune facture émise dans la sélection.",
      "purchase_document.not_found": "Pièce introuvable.",
      "purchase_document.type_invalid": "Seuls les PDF, JPEG et PNG sont acceptés.",
      "purchase_document.invalid": "Le fichier est vide ou illisible.",
      "purchase_document.too_large": "Le fichier dépasse 10 Mo.",
      "purchase_document.transmitted": "Cette pièce est déjà transmise ou en cours de transmission.",
      "purchase_document.no_channel": "Aucun canal vers le comptable : configurez l'API Inqom ou l'adresse de collecte.",
      "purchase_document.reception_open":
        "Clôturez d'abord la réception : la facture du fournisseur ne se dépose qu'ensuite, car elle part aussitôt au comptable.",
      "sav.nothing_to_return": "Aucun article restant à retourner sur ce dossier.",
      "user.not_found": "Utilisateur introuvable.",
      "user.email_taken": "Un utilisateur existe déjà avec cet e-mail.",
      "user.self": "Vous ne pouvez pas modifier votre propre rôle ou accès.",
      "order.not_archivable": "Seule une commande livrée ou annulée peut être archivée.",
      "purchase_document.supplier_mismatch": "Cette commande fournisseur appartient à un autre fournisseur.",
      "purchase_document.credit_exceeds": "Les avoirs de cette commande dépasseraient son montant.",
      "purchase.below_paid": "Le nouveau total serait inférieur à ce qui est déjà payé ou crédité sur cette commande.",
      "purchase.delivery_address_unknown":
        "Cette adresse de livraison n'existe plus dans Réglages › Identité : choisissez-en une autre.",
      "purchase.rate_not_applicable": "Une commande en euros se reçoit au taux 1.",
      "shipment.resent": "Ce colis a déjà été renvoyé : annulez plutôt le renvoi.",
      "shipment.return_via_sav": "Un colis retour se clôt par la réception du dossier SAV, qui remet les articles en stock.",
      "shipment.not_shipped": "Seul un colis parti peut être marqué livré.",
      "webhook.invalid_signature": "Signature du webhook invalide.",
    },
    field: {
      required: "Ce champ est obligatoire.",
      email: "Adresse e-mail invalide.",
      tooShort: "{min, plural, one {# caractère minimum} other {# caractères minimum}}",
      tooLong: "{max, plural, one {# caractère maximum} other {# caractères maximum}}",
      number: "Nombre invalide.",
      positive: "La valeur doit être positive.",
      siret: "SIRET invalide (14 chiffres).",
      siretKey: "SIRET invalide : un chiffre est erroné (clé de contrôle).",
      vat: "Numéro de TVA invalide.",
      date: "Date invalide.",
      password: "12 caractères minimum.",
      passwordMismatch: "Les deux mots de passe ne correspondent pas.",
      passwordUnchanged: "Le nouveau mot de passe doit être différent de l'actuel.",
      dateFuture: "La date ne peut pas être dans le futur.",
      fileTooLarge: "Fichier trop volumineux (10 Mo maximum).",
      shareTotal: "La somme des parts doit faire 100 %.",
      amountTooLarge: "Montant trop élevé (10 000 000 € maximum par montant et par document).",
      duplicateLine: "Cette ligne apparaît deux fois.",
      hsCode: "Code SH invalide (6 à 10 chiffres).",
      country: "Code pays invalide (2 lettres, ex. FR).",
      duplicateSupplier: "Ce fournisseur apparaît deux fois.",
      duplicate: "Cette valeur apparaît deux fois.",
      oneDefault: "Une seule adresse peut être celle par défaut.",
      duplicateComponent: "Ce composant apparaît deux fois.",
      composition: "Composition illisible : « REF-A + 2 x REF-B ».",
      blocks: "Chaque bloc doit apparaître une fois.",
      color: "Couleur invalide (format #RRVVBB).",
      imageType: "Image PNG ou JPEG uniquement.",
      validityBeforeIssue: "La date de validité ne peut pas précéder la date du devis.",
      totalMismatch: "Total HT + TVA différent du total TTC.",
      dateRange: "La date de fin précède la date de début.",
    },
    pages: {
      notFoundTitle: "Page introuvable",
      notFoundBody: "Cette page n'existe pas ou a été déplacée.",
      forbiddenTitle: "Accès refusé",
      forbiddenBody: "Votre rôle ne donne pas accès à cette section. Contactez un administrateur.",
      crashTitle: "Quelque chose s'est mal passé",
      crashBody: "L'erreur a été enregistrée. Rechargez la page pour continuer.",
      home: "Retour au tableau de bord",
    },
  },
  auth: {
    signInTitle: "Connexion",
    signInSubtitle: "Accédez à l'espace de gestion Phygiatech.",
    email: "E-mail professionnel",
    password: "Mot de passe",
    signIn: "Se connecter",
    signingIn: "Connexion…",
    twoFactorTitle: "Vérification en deux étapes",
    twoFactorSubtitle: "Saisissez le code à 6 chiffres de votre application d'authentification.",
    twoFactorCode: "Code de vérification",
    verify: "Vérifier",
    signedOut: "Vous êtes déconnecté.",
    roles: {
      admin: "Administrateur",
      sales: "Commercial",
      logistics: "Logistique",
      accounting: "Comptabilité",
    },
  },
  search: {
    placeholder: "Client, produit, SKU, n° de commande, facture, suivi…",
    hint: "Rechercher",
    shortcut: "⌘K",
    groups: {
      documents: "Documents",
      serials: "Numéros de série",
      navigation: "Aller à",
      actions: "Actions rapides",
      customers: "Clients",
      products: "Produits",
      suppliers: "Fournisseurs",
    },
    empty: "Aucun résultat pour « {query} »",
    actions: {
      newCustomer: "Nouveau client",
      newProduct: "Nouveau produit",
      newSupplier: "Nouveau fournisseur",
    },
  },
  dashboard: {
    period: {
      month: "Mois en cours — {month}",
      year: "Depuis janvier {year}",
      revenue: "Chiffre d'affaires HT",
      margin: "Marge",
      rate: "Taux de marge",
      uncosted: "Marge calculée hors {amount} de ventes dont le coût est inconnu (historique, articles sans coût d'achat).",
    },
    monthly: { title: "Mois par mois — {year}" },
    orders: {
      title: "Commandes",
      open: "À traiter",
      urgent: "Urgentes",
      ready: "Prêtes à préparer",
      stockout: "En rupture",
      remainder: "Reliquats à envoyer",
    },
    stock: {
      title: "Stock",
      outOfStock: "Articles en rupture",
      lowStock: "Articles sous le seuil",
      value: "Valeur du stock (prix d'achat)",
    },
    title: "Tableau de bord",
    greeting: "Bonjour {name}",
    comingSoon: "Les indicateurs apparaîtront ici au fur et à mesure que les modules seront activés.",
    asOf: "Chiffres au {date}, factures émises et avoirs déduits, montants HT",
    opsMeta: "Ce qui attend l'équipe aujourd'hui",
    kpis: {
      revenueMonth: "CA du mois",
      revenueYear: "CA cumulé {year}",
      marginMonth: "Marge du mois",
      marginYear: "Marge cumulée {year}",
      ordersMonth: "Commandes du mois",
      toInvoice: "Reste à facturer",
      overdue: "Factures en retard",
      purchasesMonth: "Achats du mois",
      stockValue: "Valeur du stock",
    },
    delta: {
      vsPrevMonth: "{delta} vs M-1",
      vsLastYear: "{delta} vs N-1",
      newVsPrevMonth: "Rien à M-1",
      newVsLastYear: "Rien à N-1",
    },
    marginRate: "{rate} du CA",
    toInvoiceOrders: "{count, plural, =0 {Aucune commande} one {# commande} other {# commandes}}",
    overdueInvoices: "{count, plural, =0 {Aucune facture} one {# facture} other {# factures}}",
    atSaleValue: "{amount} au prix de vente",
    hero: {
      ytd: "Cumul {year}",
      margin: "Taux de marge du mois",
      orders: "{count, plural, =0 {Aucune commande} one {# commande} other {# commandes}} ce mois-ci",
    },
    spark: "Évolution sur 12 mois",
    activity: {
      title: "Activité des 26 dernières semaines",
      subtitle: "Commandes reçues par jour, tous canaux",
      less: "Moins",
      more: "Plus",
      day: "{date} — {count, plural, =0 {aucune commande} one {# commande} other {# commandes}}, {amount}",
      total: "{count, plural, one {# commande} other {# commandes}} sur la période",
      busiest: "Jour le plus actif : {weekday}",
    },
    channelsTitle: "Canaux de vente du mois",
    channelsTitleYear: "Canaux de vente depuis janvier {year}",
    channelsEmpty: "Aucune vente sur la période.",
    span: { label: "Période", month: "Mois", year: "{year}" },
    flows: {
      title: "Stock acheté et revendu ce mois",
      titleYear: "Stock acheté et revendu en {year}",
      bought: "Entré (achats fournisseurs)",
      sold: "Sorti (expéditions clients)",
      units: "{count, plural, =0 {Aucun article} one {# article} other {# articles}}",
      soldValues: "{cost} au coût — {revenue} facturé",
    },
    share: "{share} du CA",
    byChannel: "Répartition par canal",
    chart: {
      title: "Chiffre d'affaires HT, 12 derniers mois",
      current: "12 derniers mois",
      previous: "Même mois, année précédente",
      showTable: "Afficher le tableau",
      showChart: "Afficher le graphique",
      month: "Mois",
      empty: "Pas encore de chiffre d'affaires sur 12 mois",
      emptyHint: "La courbe se dessine dès la première facture émise.",
      emptyInvoices: "Voir les factures",
    },
    top: {
      titleYear: "Meilleures ventes {year}",
      emptyYear: "Aucune vente facturée cette année.",
      title: "Meilleures ventes du mois",
      empty: "Aucune vente facturée ce mois-ci.",
      sold: "{count, plural, one {# vendu} other {# vendus}}",
      product: "Produit",
    },
    alerts: {
      title: "À surveiller",
      allClear: "Rien à signaler pour l'instant.",
      openOrders: "{count, plural, one {# commande à traiter} other {# commandes à traiter}}",
      stockoutOrders: "{count, plural, one {# commande en rupture} other {# commandes en rupture}}",
      urgentOrders: "{count, plural, one {# commande urgente} other {# commandes urgentes}}",
      outOfStock: "{count, plural, one {# article en rupture de stock} other {# articles en rupture de stock}}",
      lowStock: "{count, plural, one {# article sous le seuil d'alerte} other {# articles sous le seuil d'alerte}}",
      staleSav:
        "{count, plural, one {# dossier SAV ouvert depuis plus de {days} jours} other {# dossiers SAV ouverts depuis plus de {days} jours}}",
      activeSav: "{count, plural, one {# dossier SAV en cours} other {# dossiers SAV en cours}}",
      overdue: "{count, plural, one {# facture en retard de paiement} other {# factures en retard de paiement}}",
      failedWebhooks: "{count, plural, one {# commande Shopify non importée} other {# commandes Shopify non importées}}",
      failedJobs: "{count, plural, one {# tâche automatique en échec} other {# tâches automatiques en échec}}",
    },
  },
  reports: {
    title: "Rapports",
    chartTop: "Les 10 premiers, part du total de la période",
    tabs: { sales: "Ventes", purchases: "Achats", reconciliation: "Rapprochement Shopify" },
    presets: {
      label: "Période",
      month: "Ce mois",
      lastMonth: "Mois dernier",
      quarter: "Ce trimestre",
      year: "Cette année",
      lastYear: "Année dernière",
      custom: "Personnalisée",
    },
    from: "Du",
    to: "Au",
    groupBy: "Regrouper par",
    groups: { product: "Produit", customer: "Client", month: "Mois", channel: "Canal", supplier: "Fournisseur" },
    channel: "Canal",
    allChannels: "Tous les canaux",
    channels: {
      shopify: "Site web",
      quote: "Devis",
      manual: "Saisie manuelle",
      direct: "Facture directe",
      legacy: "Historique IABAKO",
    },
    columns: {
      quantity: "Qté",
      net: "CA HT",
      cost: "Coût",
      margin: "Marge",
      marginRate: "Taux de marge",
      orders: "Commandes",
      ordered: "Commandé",
      received: "Reçu",
      paid: "Payé",
      share: "Part",
    },
    total: "Total",
    export: "Exporter en CSV",
    exportXlsx: "Exporter en Excel",
    salesNote:
      "Factures émises moins avoirs, hors frais de port (lignes « Frais de port » des factures IABAKO comprises), en euros HT. La marge utilise le coût moyen figé sur chaque facture. Ce qui n'a pas de coût connu (archives IABAKO et Shopify non reprises, articles sans coût d'achat) compte dans le CA, pas dans la marge.",
    purchasesNote: "Commandes fournisseurs envoyées, converties en euros au taux enregistré.",
    emptyTitle: "Aucune donnée sur cette période",
    emptyBody: "Élargissez la période ou retirez le filtre de canal.",
    invalidRange: "La date de fin précède la date de début.",
    fileSales: "ventes",
    filePurchases: "achats",
    reconciliation: {
      intro:
        "Un même chiffre d'affaires se compte de plusieurs façons. Chaque méthode ci-dessous a une seule définition : prenez celle qui correspond au chiffre que vous comparez.",
      scope: { label: "Périmètre de l'ERP", shopify: "Site web", all: "Tous les canaux" },
      methodsTitle: "Méthodes de calcul",
      sources: { official: "Shopify, officiel", rebuilt: "Reconstitution ERP", erp: "ERP" },
      formula: "Formule",
      includes: "Inclus",
      excludes: "Exclus",
      where: "Où le retrouver",
      methods: {
        shopifyOfficial: {
          name: "Ventes totales Shopify",
          formula: "Ventes brutes − réductions − retours + expédition + taxes",
          includes:
            "Toutes les commandes du site, payées ou non, au jour de la commande ; une modification ou un remboursement compte au jour où il a lieu.",
          excludes: "Cartes-cadeaux vendues. Ventes hors du site (devis, IABAKO).",
          where: "Shopify › Analyse de données › Rapports › Ventes totales au fil du temps",
        },
        shopify: {
          name: "Ventes totales, méthode Shopify",
          formula: "Ventes brutes − réductions − retours + expédition + taxes",
          includes:
            "Le registre des ventes de Shopify, recopié par l'ERP : chaque commande, modification ou remboursement, au jour où il a eu lieu. Il doit retomber sur le rapport Shopify au centime près.",
          excludes:
            "Cartes-cadeaux et commandes de test. Rien avant le début du registre : l'API de Shopify ne donne que les 60 derniers jours.",
          where: "Calculé par l'ERP. Ce n'est pas le rapport de Shopify lui-même.",
        },
        invoicedGross: {
          name: "Facturé TTC",
          formula: "Factures émises − avoirs, TTC, frais de port compris",
          includes:
            "Les factures à leur date d'émission (commande Shopify : jour de la commande ; article modifié ou remboursé après facture : avoir ou facture complémentaire à sa date), et les archives Shopify et IABAKO.",
          excludes:
            "Commandes pas encore payées, donc pas encore facturées. Acomptes : la facture finale porte la vente. Brouillons.",
          where: "Factures",
        },
        invoicedNet: {
          name: "Facturé HT",
          formula: "Factures émises − avoirs, HT, frais de port compris",
          includes: "Les mêmes factures et avoirs que « Facturé TTC », sans la TVA.",
          excludes: "TVA. Commandes non payées, acomptes, brouillons.",
          where: "Factures",
        },
        invoicedGoods: {
          name: "CA HT des marchandises",
          formula: "Factures émises − avoirs, HT, hors frais de port",
          includes: "Le chiffre du rapport des ventes et du tableau de bord : la marge se calcule sur lui.",
          excludes: "Frais de port, refacturés au coût. TVA. Commandes non payées, acomptes, brouillons.",
          where: "Rapports › Ventes, Tableau de bord",
        },
        collected: {
          name: "Encaissé TTC",
          formula: "Paiements reçus sur les factures, à leur date",
          includes: "Les paiements enregistrés, dont ceux encaissés par Shopify au jour du paiement dans Shopify.",
          excludes:
            "L'argent rendu, que comptent les avoirs. Les paiements Shopify enregistrés avant le 14 octobre 2026 portent le jour de leur import, pas celui du paiement.",
          where: "Factures › Paiements",
        },
      },
      official: {
        missing_scope:
          "Shopify ne laisse pas encore l'ERP lire ses rapports. Il faut donner à l'application de l'ERP l'accès « read_reports » dans le Dev Dashboard de Shopify, avec l'accès aux données clients de niveau 2. D'ici là, seule la reconstitution s'affiche.",
        not_configured: "Shopify n'est pas connecté : Réglages › Intégrations.",
        error: "Le rapport de Shopify n'a pas pu être lu. Réessayez plus tard.",
      },
      shopifyTable: {
        title: "Rapport des ventes Shopify, mois par mois",
        month: "Mois",
        orders: "Commandes",
        gross: "Ventes brutes",
        discounts: "Réductions",
        returns: "Retours",
        net: "Ventes nettes",
        shipping: "Expédition",
        taxes: "Taxes",
        total: "Ventes totales",
        official: "Officiel",
        rebuilt: "Reconstitué",
        gap: "Écart",
        note: "Montants HT sauf « Taxes » et « Ventes totales ». « Retours » regroupe les articles remboursés et ceux retirés par une modification de commande.",
      },
      bridge: {
        title: "Des ventes Shopify aux factures de l'ERP",
        intro:
          "Pour la période, ce que Shopify compte en ventes totales et ce que l'ERP a facturé pour les commandes du site, TTC, commande par commande. Chaque écart est rangé selon sa cause.",
        shopify: "Ventes totales Shopify (reconstitution)",
        erp: "Factures et avoirs des commandes du site dans l'ERP",
        partial:
          "Le registre Shopify commence le {date}. Avant cette date, la colonne Shopify est incomplète : l'API ne remonte que 60 jours.",
        olderOrders:
          "Le registre couvre les commandes passées depuis le {date}. Une modification ou un remboursement fait dans la période sur une commande plus ancienne n'y figure pas : sans l'accès « read_all_orders », l'API de Shopify ne donne que les commandes des 60 derniers jours. Le rapport officiel, lui, le compte.",
        noLedger: "Le registre des ventes Shopify n'a pas encore été lu : il se remplit à la prochaine synchronisation.",
        normal: "Écart de méthode",
        anomaly: "Anomalie",
        order: "Commande",
        shopifyColumn: "Shopify",
        erpColumn: "ERP",
        gapColumn: "Écart",
        orders: "{count, plural, one {# commande} other {# commandes}}",
        none: "Aucun écart sur cette période : l'ERP facture ce que Shopify vend.",
        kinds: {
          rounding: {
            label: "Arrondis de TVA",
            help: "L'ERP calcule la TVA une fois par taux sur le total de la facture, comme l'exigent les factures françaises. Shopify la calcule ligne par ligne. L'écart est de quelques centimes par facture au plus.",
          },
          timing: {
            label: "Décalage de date",
            help: "La commande est facturée en entier, mais une partie tombe sur un autre mois. Shopify compte une modification ou un remboursement au jour où il a lieu ; une facture prise avant ce jour le compte à sa date.",
          },
          not_invoiced: {
            label: "Commandes non soldées",
            help: "Shopify compte une commande dès qu'elle est passée. L'ERP ne la facture qu'une fois payée.",
          },
          archive_dates: {
            label: "Dates de l'historique CSV",
            help: "Les commandes antérieures à l'ERP viennent de l'export CSV de Shopify, qui ne donne pas la date des remboursements. La facture y est datée du paiement, l'avoir du paiement ou de l'annulation.",
          },
          outside_ledger: {
            label: "Avant le registre Shopify",
            help: "Commande plus ancienne que le registre. L'ERP ne connaît pas le détail de ses ventes Shopify, car l'API ne remonte que 60 jours.",
          },
          document_mismatch: {
            label: "Écarts de facturation",
            help: "Sur toute la vie de la commande, l'ERP ne facture pas ce que Shopify vend : il manque un avoir ou une facture complémentaire. À corriger.",
          },
        },
        toGoods: {
          title: "Des factures TTC au CA HT du rapport des ventes",
          vat: "TVA",
          shipping: "Frais de port HT",
          goods: "CA HT des marchandises (rapport des ventes, tableau de bord)",
        },
      },
      anomalies: {
        title: "Historique des écarts",
        intro:
          "L'ERP compare chaque commande Shopify à ses factures après chaque synchronisation. Un écart reste ouvert tant qu'il existe, puis il est marqué résolu. Ce contrôle ne modifie aucun chiffre.",
        check: "Contrôler maintenant",
        checked: "Contrôle terminé",
        open: "Ouvert",
        closed: "Résolu",
        resolved: "Résolu le {date}",
        since: "Depuis le {date}",
        none: "Aucun écart enregistré.",
        amount: "ERP − Shopify",
        kinds: {
          shopify_order_missing: "Commande Shopify absente de l'ERP",
          shopify_invoice_missing: "Commande payée sans facture dans l'ERP",
          shopify_amount_mismatch: "L'ERP ne facture pas ce que Shopify vend",
          shopify_sync_failed: "Commande Shopify que la synchronisation n'arrive pas à reprendre",
        },
      },
    },
  },
  pwa: {
    updateAvailable: "Une nouvelle version est disponible.",
    updateAction: "Mettre à jour",
    offlineReady: "L'application est prête à fonctionner hors ligne.",
  },
  customers: {
    origin: { label: "Origine", all: "Toutes origines", shopify: "Site (Shopify)", pro: "Pros et administrations" },
    title: "Clients",
    singular: "Client",
    new: "Nouveau client",
    importShopify: "Importer les clients Shopify",
    importShopifyDone:
      "{created, plural, =0 {Aucun nouveau client} one {# client importé} other {# clients importés}}, {linked, plural, =0 {aucun rapproché} one {# rapproché} other {# rapprochés}}",
    searchPlaceholder: "Nom, e-mail, ville, SIRET…",
    emptyTitle: "Aucun client",
    emptyBody: "Créez votre premier client ou importez votre fichier IABAKO.",
    created: "Client créé",
    updated: "Client mis à jour",
    archived: "Client archivé",
    kinds: {
      individual: "Particulier",
      business: "Professionnel",
      public: "Administration",
    },
    fields: {
      kind: "Type de client",
      displayName: "Nom affiché",
      companyName: "Raison sociale",
      firstName: "Prénom",
      lastName: "Nom",
      siret: "SIRET",
      vatNumber: "N° de TVA intracommunautaire",
      chorusServiceCode: "Code service Chorus Pro",
      paymentTermsDays: "Délai de paiement (jours)",
      language: "Langue des documents",
      billingAddress: "Adresse de facturation",
      shippingAddress: "Adresse de livraison",
      sameAsBilling: "Identique à l'adresse de facturation",
      contacts: "Contacts",
      jobTitle: "Fonction",
      primaryContact: "Contact principal",
    },
    tabs: {
      overview: "Aperçu",
      documents: "Documents",
      history: "Historique",
    },
    activity: {
      archives: "Historique (IABAKO, Shopify)",
      archived: "Archivé",
      legacyKinds: { quote: "Devis (archive)", invoice: "Facture (archive)", credit_note: "Avoir (archive)" },
      legacySources: { iabako: "IABAKO", shopify: "Shopify" },
      legacyStatuses: {
        paid: "Payée",
        pending: "En attente",
        partially_refunded: "Remboursée en partie",
        refunded: "Remboursée",
        partially_paid: "Payée en partie",
        edited: "Modifiée",
        voided: "Annulée",
      },
      legacyCancelled: "annulée",
      quotes: "Devis",
      orders: "Commandes",
      invoices: "Factures et avoirs",
      sav: "SAV",
      receivable: "Reste à encaisser",
      empty: "Aucun document pour ce client.",
      more: "{shown} plus récents sur {total}",
    },
    noContacts: "Aucun contact enregistré.",
    addContact: "Ajouter un contact",
    moreOptions: "Conditions et notes",
    contactsCount: "{count, plural, =0 {Aucun contact} one {# contact} other {# contacts}}",
    since: "Client depuis le {date}",
    showArchived: "Archivés",
    all: "Tous",
  },
  suppliers: {
    title: "Fournisseurs",
    purchaseOrders: "Commandes fournisseur",
    singular: "Fournisseur",
    new: "Nouveau fournisseur",
    searchPlaceholder: "Nom, pays, e-mail…",
    emptyTitle: "Aucun fournisseur",
    emptyBody: "Ajoutez vos fournisseurs pour leur associer des produits.",
    created: "Fournisseur créé",
    updated: "Fournisseur mis à jour",
    languageHint: "Langue des bons de commande envoyés à ce fournisseur (textes dans Réglages › Documents).",
    languages: { fr: "Français", en: "Anglais" },
    fields: {
      language: "Langue des commandes",
      currency: "Devise d'achat",
      leadTimeDays: "Délai d'approvisionnement (jours)",
      contactName: "Contact",
      productCount: "Produits",
    },
  },
  products: {
    suppliers: {
      title: "Fournisseurs de l'article",
      hint: "{sku} : référence, prix et minimum de commande de chaque fournisseur. Le fournisseur principal pilote le réapprovisionnement.",
      open: "Fournisseurs de {sku}",
      empty: "Aucun fournisseur renseigné pour cet article.",
      supplier: "Fournisseur",
      pick: "Choisir un fournisseur",
      cost: "Prix d'achat ({currency})",
      leadTime: "Délai (jours)",
      minQuantity: "Minimum de commande",
      label: "Désignation chez ce fournisseur",
      labelHint:
        "Nom complet de l'article sur les bons de commande de ce fournisseur (sa nomenclature, options comprises). Prioritaire sur la désignation fournisseur du produit.",
      add: "Ajouter un fournisseur",
      saved: "Fournisseurs enregistrés",
    },
    title: "Produits",
    singular: "Produit",
    new: "Nouveau produit",
    searchPlaceholder: "Nom, SKU, type…",
    emptyTitle: "Aucun produit",
    emptyBody: "Importez le catalogue Shopify ou créez un produit manuellement.",
    created: "Produit créé",
    updated: "Produit mis à jour",
    importShopify: "Importer depuis Shopify",
    importShopifyDone:
      "{created, plural, =0 {Aucun nouveau produit} one {# produit importé} other {# produits importés}}, {updated, plural, =0 {aucun mis à jour} one {# mis à jour} other {# mis à jour}}",
    channels: {
      web: "Web",
      offline: "Hors web",
    },
    fields: {
      serialTracked: "Suivi par numéro de série",
      serialTrackedHint: "Chaque unité est enregistrée avec son numéro de série à la réception et choisie à l'expédition.",
      title: "Désignation",
      productType: "Famille",
      description: "Description",
      supplierLabel: "Désignation fournisseur",
      supplierLabelHint:
        "Remplace seule la désignation sur les bons de commande, sans les options : précisez-les ici, ou par variante dans l'onglet Fournisseurs. Vide = la désignation et les options en français.",
      hsCode: "Code SH (douane)",
      hsCodeHint:
        "6 à 10 chiffres, déclaré sur la CN23 d'un colis hors Union européenne. Vide = le code par défaut de Réglages › Société.",
      originCountry: "Pays d'origine",
      originCountryHint: "Code à 2 lettres (FR, CN…). Vide = le pays par défaut de Réglages › Société.",
      sku: "SKU",
      ean: "EAN",
      options: "Options",
      weightGrams: "Poids (g)",
      salePrice: "Prix de vente HT",
      salePriceTtc: "Prix de vente TTC",
      costPrice: "Coût d'achat (CUMP)",
      vatRate: "TVA",
      margin: "Marge",
      reorderPoint: "Seuil d'alerte",
      targetStock: "Stock cible",
      mainSupplier: "Fournisseur principal",
      variants: "Variantes",
      channel: "Canal",
      shopify: "Shopify",
    },
    variantCount: "{count, plural, one {# variante} other {# variantes}}",
    addVariant: "Ajouter une variante",
    costFromLedger: "Coût moyen tenu par les réceptions",
    costRevalued: "Coût moyen tenu par les réceptions : le modifier réévalue le stock",
    shopifyPrice: {
      synced: "Prix envoyé à Shopify",
      pending: "Prix en attente d'envoi à Shopify",
      pendingOff: "Prix modifié ici, pas encore envoyé : l'envoi des prix à Shopify est désactivé (Réglages › Intégrations)",
      failed: "Shopify a refusé le prix : {error}",
    },
    marginHint: "Marge {rate}",
    addAxis: "Ajouter un axe",
    axesHint: "Par exemple Taille ou Couleur. Chaque variante précise sa valeur pour chaque axe.",
    webLocked:
      "Produit vendu sur le site : désignation, famille, description, options et poids sont gérés dans Shopify et réécrits à chaque import du catalogue. Le prix se modifie ici : il est envoyé à Shopify.",
    priceTtc: "{amount} TTC",
    priceFromShopify: "Prix du site : modifié ici, il est envoyé à Shopify (TTC).",
    priceFrom: "à partir de {amount}",
    allFamilies: "Toutes les familles",
    importing: "Import en cours…",
    variantsTitle: "{count, plural, one {# variante} other {# variantes}}",
    noSupplier: "Aucun fournisseur",
    exclVat: "HT",
    weightFilter: { label: "Poids", all: "Tous les poids", missing: "Poids manquant" },
    costFilter: { label: "Coût d'achat", all: "Tous les coûts", missing: "Sans coût d'achat" },
    attach: {
      title: "Rattacher à un autre produit",
      description:
        "La variante devient une variante du produit choisi, avec ses options (taille, couleur…). Son stock, ses mouvements, ses prix fournisseurs et son historique la suivent.",
      variant: "Variante",
      target: "Produit de destination",
      targetPlaceholder: "Rechercher un produit…",
      taken: "Déjà sur ce produit : {values}",
      summary: "{sku} deviendra « {options} » de « {title} ».",
      summaryArchived: "{sku} deviendra « {options} » de « {title} ». « {source} », vide, sera archivé.",
      none: "Les variantes de ce produit viennent du site : elles restent rattachées à leur produit Shopify.",
      apply: "Rattacher",
      done: "{sku} rattaché à « {title} »",
    },
    split: {
      title: "Dissocier les variantes",
      description:
        "Crée un article par option (par exemple le gilet par taille et le cummerbund par taille). Chaque variante du site devient une composition de ces articles : le site vend toujours la combinaison, le stock est suivi article par article et un devis peut mélanger les tailles.",
      axisTitle: "Article « {name} »",
      share: "Part (%)",
      shareHint: "Du coût, du prix et du poids",
      valueFigures: "{price} HT · coût {cost}",
      kits: "Compositions des variantes du site",
      stockMoved: "{count} unités en stock passeront des variantes du site à leurs articles.",
      apply: "Dissocier",
      done: "Variantes dissociées",
    },
    composition: {
      title: "Composition",
      hint: "{sku} : articles physiques qui partent avec cette variante. Le stock, les inventaires et les achats portent sur les composants ; la variante garde son lien Shopify et son prix.",
      open: "Composition de {sku}",
      empty: "Article physique : aucun composant. Ajoutez-en pour en faire une composition.",
      component: "Composant",
      pick: "Rechercher un article par SKU ou désignation…",
      quantity: "Quantité",
      add: "Ajouter un composant",
      saved: "Composition enregistrée",
      madeOf: "Composé de",
      usedIn: "Entre dans",
      part: "{quantity} × {sku}",
      availableOf: "{available} disponible",
    },
  },
  families: {
    title: "Familles de produits",
    hint: "Les familles regroupent les produits dans les filtres, les inventaires, les poids de colis et le suivi par numéro de série. L'ordre choisi ici est celui des listes.",
    name: "Famille",
    products: "{count, plural, =0 {aucun produit} one {# produit} other {# produits}}",
    shopify: "{count, plural, one {# produit Shopify} other {# produits Shopify}}",
    shopifyHint:
      "Les produits du site reprennent leur type Shopify à chaque import ; un renommage ou une fusion faits ici restent appliqués à ce type.",
    rename: "Renommer",
    renameTitle: "Renommer la famille « {name} »",
    newName: "Nouveau nom",
    merge: "Fusionner",
    mergeTitle: "Fusionner avec « {name} » ?",
    mergeBody: "Les {count} produits de « {from} » rejoignent « {to} » ; le poids moyen de colis de « {to} » est conservé.",
    renamed: "Famille renommée",
    merged: "Familles fusionnées",
    saveOrder: "Enregistrer l'ordre",
    orderSaved: "Ordre enregistré",
    moveUp: "Monter",
    moveDown: "Descendre",
    empty: "Aucune famille : saisissez-en une sur une fiche produit.",
    datalistHint: "Choisissez une famille existante ou saisissez-en une nouvelle.",
  },
  stock: {
    reserved: { title: "Prendre des unités isolées ?", confirm: "Les prendre" },
    title: "Stock",
    serials: {
      title: "Numéros de série",
      tab: "Numéros de série",
      unit: "Unité {serial}",
      lookup: "Numéro de série",
      scan: "Scanner ou saisir un numéro, puis Entrée",
      scanHint: "Un numéro par unité ; le collage de plusieurs lignes ajoute chaque ligne.",
      count: "{count} / {expected}",
      pick: "Choisir les unités",
      pickHint: "Cochez les unités qui partent, ou scannez leur numéro.",
      inStock: "{count, plural, one {# unité en stock} other {# unités en stock}}",
      none: "Aucune unité enregistrée.",
      statuses: { in_stock: "En stock", shipped: "Expédiée", quarantine: "Quarantaine", scrapped: "Rebut", exited: "Sortie" },
      events: {
        received: "Réceptionnée",
        shipped: "Expédiée",
        returned: "Retour reçu",
        restocked: "Remise en stock",
        quarantined: "Mise en quarantaine",
        scrapped: "Mise au rebut",
        exited: "Sortie du stock",
        adjusted: "Ajustement",
        assigned: "Affectée",
        auto_assigned: "Affectée automatiquement",
        count_found: "Inventaire : trouvée",
        count_missing: "Inventaire : manquante",
      },
      pending: "Numéros affectés automatiquement, à vérifier",
      pendingHint:
        "Ce colis a été préparé hors de l'ERP (site web) : les unités ont été choisies dans l'ordre de réception. Corrigez-les si besoin.",
      confirm: "Confirmer les numéros",
      confirmed: "Numéros de série enregistrés",
      product: "Article",
      status: "État",
      history: "Historique",
      links: "Documents",
      receivedWith: "Reçue avec {number}",
      shippedWith: "Partie avec {number}",
      order: "Commande {number}",
      customer: "Client",
      sav: "SAV {number}",
      found: "Numéros trouvés",
      missing: "{count, plural, one {# numéro manquant} other {# numéros manquants}}",
      existing:
        "{count, plural, one {# unité déjà en stock : saisissez son numéro} other {# unités déjà en stock : saisissez leurs numéros}}",
      existingHint: "Le suivi démarre avec le stock actuel : chaque unité en rayon reçoit son numéro maintenant.",
      enable: "Activer le suivi",
      disable: "Désactiver le suivi",
      enabled: "Suivi par numéro de série activé",
      disabled: "Suivi par numéro de série désactivé",
      searchGroup: "Numéros de série",
    },
    tabs: { levels: "Niveaux", counts: "Inventaires", valuation: "Valorisation" },
    levels: { all: "Tous", out: "Rupture", low: "Sous le seuil", ok: "Disponible" },
    fields: {
      product: "Article",
      onHand: "Physique",
      reserved: "Réservé",
      available: "Disponible",
      incoming: "À recevoir",
      reorderPoint: "Seuil",
      unitCost: "CUMP",
      lastCount: "Dernier inventaire",
    },
    thresholdValue: "Seuil d'alerte : {value}",
    views: { articles: "Articles physiques", kits: "Compositions" },
    kit: {
      badge: "Composition",
      hint: "Stock dérivé de ses composants : c'est le composant le plus juste qui limite. Rien ne se corrige ni ne s'inventorie ici.",
      component: "{quantity} × {sku} — {available} disponible",
      emptyKits: "Aucune composition",
      emptyKitsBody: "Une composition se définit depuis la fiche produit, variante par variante.",
    },
    searchPlaceholder: "Article, SKU, famille…",
    emptyTitle: "Aucun article",
    emptyBody: "Importez ou créez des produits pour suivre leur stock.",
    adjust: "Corriger le stock",
    adjustHint: "Indiquez ce qui est réellement sur l'étagère : l'écart est enregistré dans l'historique.",
    adjustSerialsAdded: "Numéros des unités en plus",
    adjustSerialsAddedHint: "Nouvelles unités ou unités retrouvées : un numéro par unité au-delà du stock.",
    adjustSerialsMissing: "Unités manquantes",
    adjustSerialsMissingHint: "Cochez les unités qui ne sont plus sur l'étagère.",
    countedQuantity: "Quantité réellement en stock",
    countedOn: "Compté le",
    countedOnHint: "Laissez vide si le comptage vient d'être fait. Les mouvements postérieurs restent comptés.",
    note: "Motif",
    notePlaceholder: "Recomptage, casse, erreur de saisie…",
    adjusted: "Stock corrigé ({delta})",
    unchanged: "Stock inchangé",
    movements: "Mouvements",
    noMovements: "Aucun mouvement pour cet article.",
    balance: "Solde",
    lastCount: "Dernier inventaire : {date}",
    neverCounted: "Jamais inventorié",
    exit: {
      title: "Retirer du stock",
      hint: "Test, salon, prêt, casse… Les articles quittent le stock sans bon de livraison ni colis. Pour envoyer un colis, utilisez « Expédier hors commande ».",
      quantity: "Quantité",
      reason: "Motif",
      note: "Précision",
      notePlaceholder: "Nom du salon, emprunteur, circonstances…",
      done: "{count, plural, one {# article sorti} other {# articles sortis}} du stock",
      reasons: {
        test: "Test / essai",
        trade_show: "Salon",
        loan: "Prêt",
        loss: "Perte / casse",
        internal_use: "Usage interne",
        other: "Autre",
      },
    },
    movementTypes: {
      initial: "Stock initial",
      adjustment: "Correction",
      count: "Inventaire",
      purchase_receipt: "Réception fournisseur",
      sale_shipment: "Expédition client",
      sav_return: "Retour SAV",
      sav_replacement: "Remplacement SAV",
      free_shipment: "Expédition hors commande",
      resend: "Renvoi de colis",
      stock_exit: "Retrait du stock",
      shipment_cancel: "Annulation d'expédition",
      cost_revaluation: "Réévaluation du coût",
    },
    counts: {
      new: "Nouvel inventaire",
      newHint: "Les quantités comptées remplaceront le stock théorique à la date choisie.",
      countedAt: "Date de l'inventaire",
      scope: "Périmètre",
      allProducts: "Tout le catalogue",
      created: "Inventaire créé",
      statuses: { draft: "En cours", validated: "Validé", cancelled: "Annulé" },
      progress: "{counted, number} / {total, number} comptés",
      book: "Théorique",
      counted: "Compté",
      difference: "Écart",
      save: "Enregistrer le comptage",
      saved: "Comptage enregistré",
      validate: "Valider l'inventaire",
      validateTitle: "Valider l'inventaire ?",
      validateBody:
        "{count, plural, one {# écart sera enregistré} other {# écarts seront enregistrés}} à la date du {date}. Les articles non comptés ne changent pas.",
      validated: "Inventaire validé",
      cancel: "Annuler l'inventaire",
      cancelled: "Inventaire annulé",
      emptyTitle: "Aucun inventaire",
      emptyBody: "Lancez un inventaire pour saisir le stock initial ou recaler le stock théorique.",
      onlyDifferences: "Écarts uniquement",
      uncounted: "Non compté",
      lastValidated: "Dernier inventaire validé le {date}",
      noneValidated: "Aucun inventaire validé",
    },
    valuation: {
      negativeNote:
        "{count, plural, one {# article est} other {# articles sont}} en stock négatif ({quantity} unités) : valorisés à 0 et exclus des totaux, à régulariser par un inventaire ou une correction.",
      at: "Stock au",
      quantity: "Unités en stock",
      purchaseValue: "Valeur d'achat",
      saleValue: "Valeur de revente HT",
      export: "Exporter en CSV",
      filename: "valorisation-stock-{date}.csv",
      emptyTitle: "Aucun stock à cette date",
    },
  },
  quotes: {
    title: "Devis",
    singular: "Devis",
    new: "Nouveau devis",
    searchPlaceholder: "N°, client, référence…",
    emptyTitle: "Aucun devis",
    emptyBody: "Créez un devis : il deviendra une commande dès son acceptation.",
    created: "Devis créé",
    updated: "Devis enregistré",
    statuses: {
      draft: "Brouillon",
      sent: "Envoyé",
      accepted: "Accepté",
      declined: "Refusé",
      expired: "Expiré",
      cancelled: "Annulé",
    },
    fields: {
      number: "N°",
      customer: "Client",
      issueDate: "Date",
      validUntil: "Valable jusqu'au",
      reference: "Référence client",
      subject: "Objet",
      intro: "Texte d'introduction",
      introHint: "Vide : le texte du modèle (Réglages › Documents) est imprimé.",
      deliveryTime: "Délai de livraison",
      total: "Total TTC",
      margin: "Marge",
    },
    invoiced: "Facture brouillon créée depuis le devis",
    actions: {
      invoice: "Facturer",
      accept: "Accepter",
      decline: "Marquer refusé",
      cancel: "Annuler le devis",
      duplicate: "Dupliquer",
      send: "Envoyer",
      pdf: "Aperçu PDF",
      preview: "Aperçu",
      open: "Ouvrir le PDF",
      download: "Télécharger",
    },
    previewTitle: "Aperçu du devis",
    previewUnsaved: "Enregistrez le devis pour ouvrir ou télécharger son PDF.",
    previewError: "L'aperçu n'a pas pu être généré : vérifiez les champs signalés.",
    frozenPdf: "PDF figé à l'envoi : il ne change plus, même si le modèle des documents est modifié.",
    acceptTitle: "Transformer ce devis en commande ?",
    acceptBody: "La commande réserve le stock des articles et rejoint les commandes à traiter.",
    acceptDeposit: "Demander un acompte",
    acceptDepositHint: "La facture d'acompte est créée en brouillon : vous l'émettez après vérification.",
    publicHint: "Les références administratives (engagement, SIRET, bon de commande) se saisissent à l'acceptation.",
    acceptPublicBody:
      "Saisissez les références du bon de commande reçu de l'administration. Elles restent modifiables sur la commande tant qu'aucune facture n'est émise.",
    accepted: "Commande créée",
    declined: "Devis marqué refusé",
    cancelled: "Devis annulé",
    duplicated: "Devis dupliqué",
    orderLink: "Commande {number}",
    locked: "Ce devis n'est plus modifiable.",
  },
  orders: {
    board: {
      layout: "Affichage",
      list: "Liste",
      board: "Colonnes de préparation",
      empty: "Rien ici.",
      items: "{count, plural, one {# article} other {# articles}}",
    },
    title: "Commandes",
    singular: "Commande",
    new: "Nouvelle commande",
    searchPlaceholder: "N°, client, référence…",
    emptyTitle: "Aucune commande",
    emptyBody: "Les commandes du site, des devis acceptés et les saisies manuelles arrivent ici.",
    allDone: "Tout est traité",
    allDoneBody: "Aucune commande en attente dans cette vue.",
    views: {
      to_invoice: "À facturer",
      open: "À traiter",
      to_process: "Nouvelles",
      preparing: "En préparation",
      shipped: "Expédiées",
      delivered: "Livrées",
      archived: "Archivées",
      cancelled: "Annulées",
      all: "Toutes",
    },
    statuses: {
      to_process: "À traiter",
      preparing: "En préparation",
      shipped: "Expédiée",
      delivered: "Livrée",
      cancelled: "Annulée",
    },
    sources: { shopify: "Site web", quote: "Devis", manual: "Saisie" },
    payment: {
      unpaid: "Non payée",
      partially_paid: "Payée en partie",
      paid: "Payée",
      refunded: "Remboursée",
      partially_refunded: "Remboursée en partie",
    },
    flags: { urgent: "Urgent", ready: "Prête", stockout: "Rupture", remainder: "Reliquat" },
    fields: {
      allocated: "Réservé",
      orderedAt: "Date",
      customer: "Client",
      items: "Articles",
      total: "Total TTC",
      source: "Origine",
      payment: "Paiement",
      reference: "Réf. client",
      toShip: "À expédier",
      shipped: "Expédié",
      invoiced: "Facturé",
      available: "Dispo.",
    },
    allocation: {
      pick: "Sélectionner",
      quantity: "Quantité",
      selected: "{count, plural, one {# ligne sélectionnée} other {# lignes sélectionnées}}",
      isolate: "Isoler les articles",
      release: "Libérer",
      ship: "Expédier la sélection",
      deliveryNote: "Bon de livraison de la sélection",
      selectIsolated: "Sélectionner les produits isolés",
      isolatedCount: "{count, plural, one {# ligne isolée} other {# lignes isolées}}",
      done: "Articles réservés pour cette commande",
      released: "Réservation levée",
      short: "Manque en stock",
      left: "Reste {count}",
    },
    itemsCount: "{count, plural, one {# article} other {# articles}}",
    actions: {
      deliveryNote: "Bon de livraison",
      markUrgent: "Marquer urgent",
      unmarkUrgent: "Retirer l'urgence",
      prepare: "Commencer la préparation",
      delivered: "Marquer livrée",
      cancel: "Annuler la commande",
      archive: "Archiver",
      unarchive: "Désarchiver",
      invoice: "Facturer",
      depositInvoice: "Facture d'acompte",
      ship: "Expédier",
    },
    created: "Commande créée",
    updated: "Commande mise à jour",
    invoiceCreated: "Facture brouillon créée",
    cancelTitle: "Annuler cette commande ?",
    cancelBody: "Le stock réservé par ses articles sera libéré.",
    sections: { lines: "Articles", shipments: "Expéditions", invoices: "Factures", sav: "SAV", activity: "Historique" },
    noShipments: "Aucune expédition pour l'instant.",
    noInvoices: "Pas encore facturée.",
    invoicedInShopify: "Facturée dans Shopify (Simple Invoice) une fois payée : la facture apparaît ici.",
    stockoutHint: "Le stock disponible ne couvre pas toutes les lignes : réapprovisionnez ou priorisez.",
    fromQuote: "Issue du devis",
    refs: {
      title: "Références administratives",
      engagementNumber: "N° d'engagement",
      billingSiret: "SIRET de facturation",
      chorusServiceCode: "Code service Chorus",
      purchaseOrderNumber: "N° du bon de commande",
      purchaseOrder: "Bon de commande",
      signedDeliveryNote: "Bon de livraison signé",
      attachSignedDeliveryNote: "Joindre le BL signé",
      attachmentsHint:
        "Le bon de commande et le BL signé sont embarqués dans la facture Factur-X : Chorus Pro les reçoit comme pièces jointes du dépôt. 3,5 Mo au plus à eux deux.",
      attach: "Joindre le bon de commande",
      replaceFile: "Remplacer le fichier",
      removeFile: "Retirer le fichier",
      edit: "Modifier les références",
      defaultsHint: "Vides, le SIRET et le code service de la fiche client s'appliquent à la facture.",
      locked: "Une facture est émise : ces références sont figées.",
      missing: "Pas encore reçues : saisissez-les à réception du bon de commande.",
      saved: "Références enregistrées",
    },
  },
  invoices: {
    correctsLink: "Avoir sur {number}",
    title: "Factures",
    singular: "Facture",
    new: "Nouvelle facture",
    searchPlaceholder: "N°, client…",
    emptyTitle: "Aucune facture",
    emptyBody: "Facturez une commande ou créez une facture libre.",
    kinds: { invoice: "Facture", credit_note: "Avoir", deposit: "Facture d'acompte" },
    depositLine: "Acompte de {share} sur {document}",
    deposit: {
      title: "Facture d'acompte",
      create: "Demander un acompte",
      hint: "Une facture d'acompte est créée en brouillon ; le reste de la commande sera facturé net de cet acompte.",
      share: "Part de la commande (%)",
      amount: "ou montant TTC",
      ofTotal: "sur {total} TTC",
      preview: "Acompte : {amount} TTC",
      readOnly: "Lignes calculées depuis la commande : supprimez cette facture pour demander un autre montant.",
      deductedOn: "Repris sur la facture {number}",
      deducted: "Acomptes déduits",
      deductedLine: "{number} du {date} : {amount} HT",
      created: "Facture d'acompte créée",
    },
    takenOver:
      "Facture reprise d'IABAKO avec son numéro et ses lignes : l'original reste dans IABAKO, l'ERP en reproduit le PDF. Les paiements et l'avoir éventuel se gèrent ici.",
    issuers: { erp: "ERP", shopify: "Shopify", iabako: "IABAKO" },
    external: {
      badge: "Shopify",
      banner:
        "Facture émise dans Shopify (Simple Invoice) sous le numéro de commande {number} : l'original fait foi. L'ERP peut en reproduire le PDF.",
      creditNoteBanner:
        "Avoir émis dans Shopify (Simple Invoice) pour le remboursement de la commande {number} : l'original fait foi. L'ERP peut en reproduire le PDF.",
      open: "Ouvrir la commande dans Shopify",
    },
    export: {
      action: "Exporter les PDF",
      hint: "Une archive ZIP pour le comptable : le PDF de chaque facture et avoir émis sur la période, avec un récapitulatif CSV.",
      download: "Télécharger l'archive",
      includeExternal: "Inclure les factures Shopify",
      includeExternalHint: "Reproduites par l'ERP à partir des commandes. Le récapitulatif les liste dans tous les cas.",
      filename: "factures-{from}-{to}.zip",
      downloaded: "Archive téléchargée",
      columns: {
        number: "N°",
        kind: "Type",
        issuer: "Émetteur",
        date: "Date",
        customer: "Client",
        net: "Total HT",
        vat: "TVA",
        gross: "Total TTC",
        paid: "Encaissé",
      },
    },
    statuses: { draft: "Brouillon", issued: "Émise", cancelled: "Annulée" },
    filters: {
      all: "Toutes",
      unpaid: "À encaisser",
      overdue: "En retard",
      paid: "Soldées",
      drafts: "Brouillons",
      creditNotes: "Avoirs",
      shopify: "Shopify",
      iabako: "IABAKO",
    },
    summary: { receivable: "À encaisser", overdue: "Dont en retard" },
    fields: {
      number: "N°",
      customer: "Client",
      issueDate: "Émise le",
      dueDate: "Échéance",
      total: "Total TTC",
      paid: "Encaissé",
      balance: "Reste dû",
      credited: "Avoirs",
    },
    chorus: {
      title: "Chorus Pro",
      resubmit: "Redéposer",
      queued: "Dépôt Chorus Pro programmé",
      states: {
        none: "Non déposée",
        queued: "En file",
        depositing: "Dépôt en cours",
        uncertain: "Dépôt à vérifier",
        deposited: "Déposée",
        integrated: "Intégrée",
        rejected: "Rejetée",
        not_configured: "Raccordement absent",
      },
    },
    inqom: {
      title: "Comptable (Inqom)",
      resubmit: "Redéposer",
      queued: "Dépôt chez Inqom programmé",
      document: "Pièce Inqom n° {id}",
      states: {
        none: "Non déposé",
        queued: "En file",
        depositing: "Dépôt en cours",
        uncertain: "Dépôt à vérifier",
        deposited: "Déposé",
        failed: "Échec",
        not_configured: "Raccordement absent",
      },
    },
    actions: {
      issue: "Émettre",
      delete: "Supprimer le brouillon",
      addPayment: "Enregistrer un paiement",
      creditNote: "Annuler / Avoir",
      reinvoice: "Refacturer la commande",
      unpay: "Remettre en attente de paiement",
      send: "Envoyer",
      pdf: "Aperçu PDF",
      download: "Télécharger",
    },
    bulk: {
      download: "{count, plural, one {Télécharger # facture} other {Télécharger # factures}}",
      clear: "Tout désélectionner",
      filename: "factures-selection-{date}.zip",
      downloaded: "Archive téléchargée",
      tooMany: "{max} factures au plus par téléchargement.",
    },
    issueTitle: "Émettre ce document ?",
    issueBody: "Un numéro définitif lui est attribué et il ne pourra plus être modifié : toute correction passera par un avoir.",
    issued: "{number} émis",
    deleted: "Brouillon supprimé",
    saved: "Brouillon enregistré",
    draftHint: "Brouillon non numéroté : vous pouvez encore le modifier.",
    overdue: "En retard",
    accountingSent: "Transmis au comptable le {date}",
    related: "Documents liés",
    paymentsTitle: "Paiements",
    noPayments: "Aucun paiement enregistré.",
    paymentAdded: "Paiement enregistré",
    paymentRemoved: "Paiement supprimé",
    reinvoiced: "Commande remise à facturer : nouveau brouillon de facture",
    paymentsCleared: "Facture remise en attente de paiement",
    payment: {
      amount: "Montant",
      paidAt: "Date",
      method: "Mode",
      reference: "Référence",
      methods: { transfer: "Virement", card: "Carte", check: "Chèque", cash: "Espèces", shopify: "Shopify", other: "Autre" },
    },
    creditNote: {
      title: "Annuler la facture ou établir un avoir",
      whole: "Avoir sur la totalité",
      partial: "Choisir les lignes",
      reason: "Motif",
      created: "Avoir brouillon créé",
      readOnly: "Lignes reprises de la facture corrigée : supprimez ce brouillon pour établir un autre avoir.",
    },
  },
  editor: {
    customer: "Client",
    pickCustomer: "Rechercher un client…",
    lines: "Lignes",
    searchProduct: "Ajouter un article : nom ou SKU…",
    addFreeLine: "Ligne libre",
    freeLineLabel: "Désignation",
    columns: {
      designation: "Désignation",
      quantity: "Qté",
      unitPrice: "P.U. HT",
      discount: "Remise %",
      vat: "TVA",
      total: "Total HT",
    },
    removeLine: "Retirer la ligne",
    detailKit: "Détailler en articles (tailles séparées)",
    moveUp: "Monter",
    moveDown: "Descendre",
    description: "Description",
    addDescription: "Ajouter une description",
    globalDiscount: "Remise globale %",
    shipping: "Frais de port HT",
    notes: "Notes affichées sur le document",
    terms: "Conditions particulières",
    totals: {
      deposit: "Acompte déjà facturé ({number})",
      subtotal: "Sous-total HT",
      globalDiscount: "Remise globale",
      shipping: "Frais de port",
      net: "Total HT",
      vat: "TVA {rate}",
      gross: "Total TTC",
      cost: "Coût de revient",
      margin: "Marge",
    },
    lowMargin: "Marge sous le seuil de {rate}",
    availability: "{count, number} dispo.",
    noLines: "Ajoutez un article ou une ligne libre.",
    unsaved: "Modifications non enregistrées",
  },
  email: {
    title: "Envoyer par e-mail",
    to: "Destinataire",
    cc: "Copie",
    subject: "Objet",
    message: "Message",
    attachment: "Le PDF est joint automatiquement.",
    send: "Envoyer",
    queued: "E-mail en cours d'envoi",
    history: "Envois",
    statuses: { queued: "En file", sent: "Envoyé", failed: "Échec" },
    notConfigured: "L'envoi d'e-mails n'est pas encore configuré : téléchargez le PDF pour l'envoyer depuis votre messagerie.",
  },
  company: {
    logo: "Logo des documents",
    logoHint: "PNG ou JPEG, 2 Mo maximum. Imprimé en tête des devis, factures, bons de livraison et commandes fournisseurs.",
    logoDefault: "Logo Phygiatech",
    logoUpload: "Changer le logo",
    logoRemove: "Revenir au logo Phygiatech",
    title: "Société et documents",
    identity: "Identité légale",
    legalName: "Raison sociale",
    tradeName: "Nom commercial",
    legalForm: "Forme juridique",
    capital: "Capital social",
    siren: "SIREN",
    rcs: "RCS",
    vatNumber: "N° de TVA",
    deliveryAddresses: {
      title: "Adresses de livraison des achats",
      hint: "Où vos fournisseurs livrent (entrepôt, chez un associé…). L'adresse ci-dessus reste celle de facturation. La commande fournisseur garde l'adresse choisie, même si vous la modifiez ensuite ici.",
      name: "Nom de l'adresse",
      nameHint: "Par exemple « Entrepôt Storage24 » : c'est ce que vous choisirez sur la commande.",
      contact: "Contact (prénom et nom)",
      default: "Par défaut",
      add: "Ajouter une adresse",
      none: "Aucune : les commandes fournisseur sont livrées à l'adresse de la société.",
      company: "Adresse de la société",
      removed: "{name} (retirée des réglages)",
    },
    eori: "N° EORI",
    eoriHint:
      "Numéro douanier (importations et exportations hors UE), imprimé sur les bons de commande fournisseur et transmis à Colissimo pour les colis hors UE.",
    customs: "Douane",
    customsHint:
      "Valeurs par défaut de la déclaration CN23 d'un colis hors Union européenne ou vers l'outre-mer, pour les articles qui n'ont pas les leurs sur leur fiche.",
    customsOriginCountry: "Pays d'origine par défaut (2 lettres)",
    customsHsCode: "Code SH par défaut",
    contact: "Coordonnées",
    bank: "Coordonnées bancaires",
    bankHint: "Affichées sur les factures pour le règlement par virement.",
    iban: "IBAN",
    bic: "BIC",
    documents: "Documents",
    quoteValidityDays: "Validité des devis (jours)",
    defaultPaymentTermsDays: "Délai de paiement par défaut (jours)",
    marginAlert: "Alerte de marge sous (%)",
    archiveAfterDays: "Archiver les commandes livrées ou annulées après (jours)",
    savAlertDays: "Signaler un dossier SAV ouvert depuis (jours)",
    defaults: "Délais et seuils",
    accounting: "Comptabilité",
    accountingEmail: "Adresse de collecte de l'expert-comptable (Inqom)",
    accountingHint: "Chaque facture et avoir émis y est envoyé automatiquement.",
    webInvoiceMode: "Factures des commandes du site",
    creditNoteEngagement: "Reprendre le numéro d'engagement sur les avoirs",
    autoReplenish: "Réapprovisionnement automatique",
    depositInvoices: "Factures d'acompte",
    depositDefaultBp: "Acompte proposé par défaut (%)",
    serialTracking: "Suivi par numéro de série",
    serialTypes: "Articles suivis, par type de produit",
    serialTypeRow: "{tracked} / {products} produits suivis — {onHand} unités en stock",
    serialTypeBlocked: "{product} : {message}",
    serialEnableType: "Suivre tout le type",
    serialDisableType: "Ne plus suivre le type",
    parcelWeights: "Poids moyens des colis",
    parcelWeightsHint:
      "Poids compté pour un article sans poids propre, selon son type de produit : sert à estimer les étiquettes de retour, les remplacements et les échanges du SAV.",
    parcelWeightOf: "{type} (g)",
    noFamily: "Sans famille",
    parcelWeightDefault: "Autres articles (g)",
    parcelWeightTypeHint: "Vide : le poids des autres articles s'applique.",
    parcelFormats: "Colis La Poste Pro Expédition",
    parcelFormatsHint:
      "Dimensions et catégorie de contenu du fichier d'envois pour une commande dont le carton n'a pas encore été choisi.",
    parcelFormatDefault: "Format par défaut",
    parcelDimensions: "L × l × H (cm)",
    parcelCategory: "Catégorie de contenu La Poste",
    saved: "Réglages enregistrés",
  },
  sav: {
    title: "SAV",
    singular: "Dossier SAV",
    new: "Nouveau dossier",
    searchPlaceholder: "Rechercher un dossier, un client, un objet…",
    statuses: {
      open: "Ouvert",
      awaiting_return: "Retour attendu",
      received: "Retour reçu",
      resolved: "Résolu",
      closed: "Clôturé",
    },
    views: {
      active: "En cours",
      open: "Ouverts",
      awaiting_return: "Retour attendu",
      received: "Reçus",
      resolved: "Résolus",
      closed: "Clôturés",
    },
    reasons: {
      defect: "Défaut produit",
      damaged: "Endommagé au transport",
      size_exchange: "Échange de taille",
      product_exchange: "Échange de produit",
      wrong_item: "Erreur d'article",
      withdrawal: "Rétractation",
      cancellation: "Annulation",
      other: "Autre",
    },
    resolutions: { refund: "Remboursement", replacement: "Remplacement", repair: "Réparation", none: "Sans suite" },
    conditions: { restock: "Remis en stock", quarantine: "Quarantaine", scrap: "Rebut" },
    kinds: { sav: "SAV", exchange: "Échange", return: "Retour" },
    kindHints: {
      sav: "Problème produit : diagnostic, retour éventuel, puis remplacement, réparation ou remboursement.",
      exchange: "Autre taille ou autre modèle : le nouvel article part avec une étiquette de retour dans le colis.",
      return: "Rétractation ou annulation : le client renvoie l'article, puis il est remboursé.",
    },
    allKinds: "Tous les types",
    fields: {
      returnTo: "Destinataire du retour",
      returnFrom: "Expéditeur (le client)",
      returnToName: "Nom (bureau de poste, entrepôt…)",
      emailLabel: "Envoyer l'étiquette par e-mail au client ({email})",
      contactName: "Nom du client",
      article: "Article concerné",
      photos: "Photos ou documents",
      number: "N°",
      kind: "Type de demande",
      customer: "Client",
      subject: "Objet",
      reason: "Motif",
      resolution: "Résolution",
      description: "Description",
      order: "Commande",
      age: "Ouvert",
      lines: "Articles concernés",
      quantity: "Qté",
      received: "Reçu",
      condition: "État",
      label: "Désignation",
      variant: "Article du catalogue",
      tracking: "N° de suivi",
      generateLabel: "Générer l'étiquette Colissimo",
      creditNote: "Avoir",
      quote: "Devis",
      sentVariant: "Article envoyé",
      returnTracking: "N° de suivi du retour",
    },
    sections: {
      lines: "Articles",
      timeline: "Suivi du dossier",
      shipments: "Envois liés",
      customer: "Client",
      links: "Documents liés",
    },
    events: {
      undo: "Action annulée",
      email: "Étiquette retour envoyée par e-mail à {to}",
      note: "Note",
      status: "Statut : {status}",
      statusResolution: "Résolu : {resolution}",
      returnLabel: "Étiquette retour {number}",
      laposteReturn: "Fichier La Poste du retour généré",
      replacement: "Remplacement expédié {number}",
      receipt: "Retour reçu ({count, plural, one {# article} other {# articles}})",
      refundShopify: "Remboursement à faire dans Shopify",
      refundShopifyApi: "Remboursement lancé dans Shopify",
      refundCredit: "Avoir brouillon créé",
    },
    actions: {
      undo: "Annuler la dernière action",
      create: "Ouvrir le dossier",
      openFromOrder: "Ouvrir un SAV",
      returnLabel: "Étiquette retour seule",
      laposteReturn: "Fichier La Poste (retour)",
      receive: "Réceptionner le retour",
      replace: "Envoyer un produit",
      refund: "Rembourser",
      resolveRepair: "Résoudre : réparation",
      resolveNone: "Résoudre : sans suite",
      close: "Clôturer",
      reopen: "Rouvrir",
      addNote: "Ajouter la note",
      addLine: "Ajouter un article",
      openLabel: "Ouvrir l'étiquette",
      viewCreditNote: "Voir l'avoir",
      attach: "Joindre un fichier",
      exchange: "Produit + étiquette retour",
      changeOrder: "Changer de commande",
      withoutOrder: "Dossier sans commande",
      withOrder: "Rattacher à une commande",
    },
    hints: {
      contactName:
        "Commande groupée : le nom de la personne concernée, s'il diffère du client de la commande. Il apparaît sur le dossier et ses étiquettes.",
      photos: "Photos du client (dommage, étiquette…) : jointes au dossier dès sa création.",
      fromOrder: "Cochez les articles concernés par la demande.",
      orderFirst: "Choisissez la commande : ses articles s'afficheront ici.",
      noOrder: "Sans commande liée : choisissez le client et décrivez les articles.",
      condition:
        "Seuls les articles « Remis en stock » réintègrent le stock vendable. La quarantaine et le rebut restent tracés sur le dossier.",
      returnLabel:
        "Crée l'étiquette retour (PDF à transmettre au client). Rien ne sort du stock ; le dossier attend le colis, contrôlé à sa réception.",
      laposteReturn:
        "Fichier à importer dans La Poste Pro Expédition pour éditer l'étiquette retour (colis adressé à la société, poids et format selon les articles). Le dossier passe en attente du colis.",
      laposteReturnDone: "Fichier retour téléchargé",
      labelUnavailable: "Colissimo n'est pas configuré : saisissez le numéro de suivi manuellement.",
      replacement:
        "Envoie les articles de remplacement tout de suite (ils sortent du stock, bon de livraison créé), sans attendre de retour ; le dossier est résolu.",
      refundShopify:
        "Cette commande vient de Shopify : l'ERP rembourse le client dans Shopify si l'écriture vers Shopify est activée, sinon faites-le dans l'admin Shopify. L'avoir est créé à la réception du remboursement.",
      refundCredit: "Un avoir brouillon sera préparé sur la facture de la commande, à vérifier puis émettre.",
      notePlaceholder: "Échange avec le client, constat, décision…",
      stale: "Ouvert depuis plus de 14 jours",
      noLines: "Aucun article sur ce dossier.",
      noShipments: "Aucun envoi pour l'instant.",
      pickOrder: "Retrouvez la commande par son numéro ou le nom du client pour cocher les articles concernés.",
      exchange:
        "Le nouvel article sort du stock et part avec l'étiquette de retour dans le colis. Le dossier attend ensuite l'article renvoyé, contrôlé à sa réception.",
      sameVariant: "Choisissez l'article à envoyer s'il diffère (autre taille, autre modèle).",
    },
    refundTitle: "Rembourser ce dossier ?",
    closeTitle: "Clôturer ce dossier ?",
    closeBody: "Le dossier passe en lecture seule. Vous pourrez le rouvrir si besoin.",
    empty: "Aucun dossier SAV en cours",
    emptyBody: "Les demandes clients apparaîtront ici dès leur ouverture.",
    created: "Dossier SAV ouvert",
    updated: "Dossier mis à jour",
    noteAdded: "Note ajoutée",
    refundedCredit: "Avoir brouillon créé",
    refundedShopify: "Remboursement enregistré ; finalisez-le dans Shopify",
    refundedShopifyApi: "Remboursement lancé dans Shopify ; l'avoir suivra",
    attachmentAdded: "Fichier joint",
    pickCustomer: "Choisir un client",
    wholeSet: "Tout l'ensemble",
    returnEmail: {
      subject: "Votre étiquette de retour — {company} (dossier {number})",
      body: "Bonjour {name},\n\nVous trouverez ci-joint l'étiquette de retour pour votre dossier {number}. Imprimez-la, collez-la sur le colis et déposez-le à La Poste.\n\nCordialement,\n{company}",
    },
    returnParcel: "Colis retour",
    sentParcel: "Colis envoyé",
    returnToCompany: "L'adresse de l'entreprise (aucune adresse de retour réglée)",
    undoTitle: "Annuler la dernière action ?",
    undoBody:
      "Le dossier revient à son état d'avant : les colis créés sont annulés (ce qui était parti revient en stock ; une étiquette déjà imprimée n'est simplement pas utilisée), une réception est retirée du stock. Un remboursement ne s'annule pas ici.",
    pickKind: "Type de demande",
    pickKindFirst: "Choisissez d'abord le type de demande",
    pickReason: "Choisir un motif",
    pickVariant: "Rechercher un article (facultatif)",
    pickOrder: "N° de commande ou nom du client",
    pickSentVariant: "Même article",
  },
  parcels: {
    labelFormat: "Format des étiquettes Colissimo",
    labelFormatHint:
      "10×15 pour une imprimante d'étiquettes thermique, A4 pour une imprimante ordinaire (l'étiquette est au format 10×15 sur la page). Un retour international sort toujours en A4.",
    labelFormats: { PDF_10x15_300dpi: "10×15 cm (imprimante d'étiquettes)", PDF_A4_300dpi: "A4 (imprimante ordinaire)" },
    chronopostLabelFormat: "Format des étiquettes Chronopost",
    chronopostLabelFormatHint:
      "Une page A4 avec ou sans la preuve de dépôt pour une imprimante ordinaire, ou une étiquette 10×15 pour une imprimante d'étiquettes thermique.",
    chronopostLabelFormats: {
      PDF: "A4 avec preuve de dépôt (imprimante ordinaire)",
      SPD: "A4 sans preuve de dépôt (imprimante ordinaire)",
      THE: "10×15 cm (imprimante d'étiquettes)",
    },
    printLabel: "Imprimer l'étiquette",
    parcel: "Colis {n}",
    summary: "Colis {n} — {length}×{width}×{height} cm",
    summaryEnvelope: "Colis {n} — pli {length}×{width} cm",
    envelope: "Pli (enveloppe, sans hauteur)",
    freeEnvelope: "Pli libre (dimensions à saisir)",
    envelopeBadge: "Pli",
    weight: "{grams} g",
    box: "Carton",
    free: "Format libre (dimensions à saisir)",
    length: "Longueur (cm)",
    width: "Largeur (cm)",
    height: "Hauteur (cm)",
    add: "Ajouter un colis",
    weightHint: "Proposé : {grams} g (articles + carton vide).",
    boxes: "Cartons",
    boxesHint:
      "Les cartons que vous avez en stock : choisis à l'expédition, leurs dimensions partent dans le fichier La Poste avec le poids. « Format libre » reste toujours possible.",
    boxName: "Nom",
    emptyGrams: "Poids à vide (g)",
    addBox: "Ajouter un carton",
    laposteFile: "Fichier La Poste",
    count: "{count, plural, one {# colis} other {# colis}}",
  },
  shipments: {
    title: "Expéditions",
    singular: "Expédition",
    newTitle: "Préparer un envoi",
    newSubtitle: "Commande {number}",
    searchPlaceholder: "N° d'envoi, commande, client, suivi",
    filters: { allStatuses: "Tous les statuts", allCarriers: "Tous les transporteurs", from: "Du", to: "Au" },
    statuses: { draft: "Brouillon", ready: "Prêt", shipped: "Expédié", delivered: "Livré", cancelled: "Annulé" },
    kinds: {
      outbound: "Envoi client",
      return: "Retour SAV",
      replacement: "Remplacement SAV",
      free: "Hors commande",
      resend: "Renvoi",
    },
    views: { all: "Tous" },
    carriers: { colissimo: "Colissimo", chronopost: "Chronopost", other: "Autre transporteur" },
    services: { DOM: "Colissimo domicile sans signature", DOS: "Colissimo domicile avec signature", COLD: "Colissimo Expert" },
    fields: {
      number: "N° BL",
      recipient: "Destinataire",
      order: "Commande",
      date: "Date",
      tracking: "N° de suivi",
      carrier: "Transporteur",
      service: "Service",
      weight: "Poids (g)",
      remaining: "Reste",
      onHand: "Stock",
      toShip: "À expédier",
      shippedAt: "Expédié le",
      deliveredAt: "Livré le",
      address: "Adresse de livraison",
      sav: "Dossier SAV",
      note: "Motif",
    },
    sections: {
      lines: "Contenu du colis",
      parcel: "Colis",
      recipient: "Destinataire",
      tracking: "Suivi",
      activity: "Historique",
    },
    actions: {
      ship: "Valider l'envoi",
      deliveryNote: "Bon de livraison",
      label: "Étiquette",
      setTracking: "Saisir le suivi",
      editTracking: "Modifier le suivi",
      delivered: "Marquer livré",
      track: "Suivre le colis",
      openOrder: "Voir la commande",
      openSav: "Voir le dossier SAV",
      shipAll: "Tout expédier",
      shipNone: "Tout vider",
      resend: "Renvoyer",
    },
    hints: {
      noColissimo:
        "Aucun transporteur n'est raccordé (Colissimo, Chronopost) : saisissez le numéro de suivi de l'étiquette faite ailleurs.",
      generateLabel: "Générer l'étiquette Colissimo",
      generateLabelChronopost: "Générer l'étiquette Chronopost",
      generateLabelHint: "L'étiquette est créée à la validation ; si le transporteur la refuse, rien n'est enregistré.",
      trackingOptional: "Facultatif, peut être saisi plus tard.",
      weight: "Pré-calculé à partir du poids des articles.",
      stockShort:
        "Stock insuffisant pour {count, plural, one {# article} other {# articles}}. L'envoi reste possible mais le stock passera en négatif.",
      nothingToShip: "Tout est déjà expédié pour cette commande.",
      noTracking: "Pas encore de numéro de suivi.",
      stockLeaves: "Le stock sort à la validation ; la commande et Shopify sont mis à jour.",
    },
    toasts: { shipped: "Envoi {number} validé", tracking: "Suivi enregistré", delivered: "Envoi marqué livré" },
    cancel: {
      action: "Annuler l'expédition",
      title: "Annuler l'expédition {number} ?",
      stock: "Les articles du colis reviennent en stock, au coût auquel ils sont sortis.",
      serials: "Les numéros de série du colis repassent en stock.",
      order: "La commande {number} repasse en préparation : les quantités de ce colis sont de nouveau à expédier.",
      label: "L'étiquette n'est pas annulée chez le transporteur : faites-le depuis son espace si elle a été payée.",
      done: "Expédition {number} annulée",
    },
    empty: { title: "Aucune expédition", body: "Les envois se préparent depuis une commande à traiter." },
    trackingTitle: "Numéro de suivi",
    free: {
      action: "Expédier hors commande",
      title: "Expédition hors commande",
      subtitle: "Échantillon, prêt, salon, usage interne : envoi sans commande",
      linesHint: "Articles qui quittent le stock.",
      noteHint: "Imprimé sur le bon de livraison et dans le journal de stock.",
      stockLeaves: "Le stock sort à la validation, avec bon de livraison et étiquette.",
    },
    laposte: {
      action: "Fichier La Poste Pro Expédition",
      actionCount: "Fichier La Poste ({count, plural, one {# commande} other {# commandes}})",
      hint: "À importer dans La Poste Pro Expédition (Importer des envois par fichier) : les étiquettes se font là-bas, le numéro de suivi revient par Shopify ou se saisit sur l'envoi.",
      filename: "laposte-pro-expedition-{date}.csv",
      downloaded: "Fichier La Poste téléchargé",
      nothing: "Aucune commande à expédier dans cette liste.",
    },
    resend: {
      title: "Renvoyer ce colis",
      hint: "Même contenu, même adresse que {number}. Les articles ressortent du stock.",
      notePlaceholder: "Colis perdu, arrivé abîmé…",
    },
  },
  purchasing: {
    close: "Clôturer la réception",
    closeTitle: "Clôturer la réception ?",
    closeBody:
      "Ce qui est arrivé est ce que la commande a livré : les quantités non reçues ne sont plus attendues en stock et ne sont pas dues, sans avoir à demander. La commande passe « Facture à déposer » jusqu'au dépôt de la facture du fournisseur. Irréversible.",
    closeReason: "Motif (facultatif)",
    closed: "Réception clôturée le {date}",
    invoicePendingHint:
      "Facture à déposer : déposez la facture du fournisseur dans « Pièces jointes ». Elle part au comptable et la commande est archivée.",
    title: "Achats",
    allSuppliers: "Tous les fournisseurs",
    singular: "Commande fournisseur",
    new: "Nouvelle commande fournisseur",
    searchPlaceholder: "N°, fournisseur, référence…",
    views: { orders: "Commandes", suggestions: "À réapprovisionner", payables: "À payer", documents: "Pièces" },
    documents: {
      title: "Pièces d'achat",
      hint: "Factures fournisseurs, tickets de caisse et contrats, conservés ici et transmis au comptable (API Inqom ou adresse de collecte).",
      drop: "Déposez vos fichiers ici ou",
      choose: "choisissez-les",
      accepted: "PDF, JPEG ou PNG, 10 Mo au plus par fichier.",
      uploaded: "{count, plural, one {# pièce déposée} other {# pièces déposées}}",
      creditHint:
        "Facultatif : le montant de l'avoir, dans la devise de la commande et sur la même base que son total (sans TVA), est déduit du reste à payer de la commande. Inutile pour la marchandise jamais livrée d'une réception clôturée.",
      creditNoOrder: "Avoir non rattaché à une commande : il n'est déduit d'aucun reste à payer.",
      uploadSheet: {
        title: "{count, plural, one {Déposer # pièce} other {Déposer # pièces}}",
        description: "Précisez la nature de la pièce avant son envoi au comptable : elle lui est transmise dès le dépôt.",
        batchHint: "Le type et la date s'appliquent à chacun des fichiers.",
        creditOneByOne: "Déposez les avoirs un par un : chacun a son montant.",
        invoiceAfterClose:
          "La facture du fournisseur se dépose une fois la réception clôturée : elle part au comptable dès le dépôt et doit refléter ce qui a été livré.",
        submit: "Déposer",
      },
      kinds: {
        supplier_invoice: "Facture fournisseur",
        supplier_credit: "Avoir fournisseur",
        receipt: "Ticket de caisse",
        contract: "Contrat",
        other: "Autre",
      },
      fields: {
        name: "Fichier",
        kind: "Type",
        date: "Date de la pièce",
        amount: "Montant",
        supplier: "Fournisseur",
        purchaseOrder: "Commande fournisseur",
        note: "Note",
        transmission: "Comptable",
      },
      filters: { all: "Toutes", pending: "À transmettre", transmitted: "Transmises" },
      transmission: {
        none: "Non transmise",
        queued: "En file",
        depositing: "Dépôt en cours",
        uncertain: "Dépôt à vérifier",
        deposited: "Déposée chez Inqom",
        failed: "Échec",
        not_configured: "Raccordement absent",
        email: "Envoyée par e-mail",
      },
      actions: {
        open: "Ouvrir",
        edit: "Modifier",
        transmit: "Transmettre",
        transmitPending: "Transmettre les pièces en attente",
        attach: "Joindre une pièce",
        delete: "Supprimer",
      },
      edited: "Pièce enregistrée",
      deleted: "Pièce supprimée",
      transmitted: "Transmission programmée",
      pendingQueued: "{count, plural, =0 {Aucune pièce en attente} one {# pièce programmée} other {# pièces programmées}}",
      deleteTitle: "Supprimer cette pièce ?",
      deleteBody: "Le fichier est retiré de l'ERP. Une pièce déjà transmise au comptable ne peut pas être supprimée.",
      emptyTitle: "Aucune pièce",
      emptyBody: "Déposez une facture fournisseur, un ticket ou un contrat.",
      onOrder: "Pièces jointes",
      noneOnOrder: "Aucune pièce jointe à cette commande.",
    },
    payables: {
      due: "Reste à payer",
      all: "Tout l'historique",
      total: "Reste à payer aux fournisseurs :",
      toRecover: "à récupérer (trop-versé, commande annulée) :",
      expected: "Livraison prévue le {date}",
      lastPaid: "dernier paiement le {date}",
      credited: "avoirs {amount}",
      paidOf: "{paid} payés sur {total}",
      emptyTitle: "Rien à payer",
      emptyBody: "Toutes les commandes fournisseurs envoyées sont soldées.",
    },
    statusFilter: { open: "En cours", auto: "Réappro auto", archived: "Archivées", all: "Toutes" },
    emptyTitle: "Aucune commande fournisseur",
    emptyBody: "Créez une commande ou partez des suggestions de réapprovisionnement.",
    created: "Commande fournisseur créée",
    updated: "Commande fournisseur enregistrée",
    statusUpdated: "Statut mis à jour",
    statuses: {
      draft: "Brouillon",
      sent: "Envoyée",
      confirmed: "Confirmée",
      partially_received: "Reçue en partie",
      received: "Entièrement reçue",
      invoice_pending: "Facture à déposer",
      closed: "Clôturée",
      cancelled: "Annulée",
    },
    fields: {
      number: "N°",
      supplier: "Fournisseur",
      currency: "Devise",
      exchangeRate: "Taux de change",
      exchangeRateHint: "Valeur de 1 {currency} en euros. Le coût entre en stock à ce taux lors de la réception.",
      orderedAt: "Date de commande",
      expectedAt: "Livraison souhaitée",
      deliveryAddress: "Livré à",
      deliveryAddressHint: "Adresses de livraison gérées dans Réglages › Identité ; imprimée sur le bon de commande.",
      supplierReference: "Référence fournisseur",
      notes: "Notes pour le fournisseur",
      progress: "Reçu",
      progressValue: "{received} / {ordered}",
      total: "Total HT",
      paid: "Payé",
      credited: "Avoirs fournisseur",
      remainingToPay: "Reste à payer",
      invoiced: "Facturé par le fournisseur",
      receivedValue: "Valeur reçue",
      item: "Article",
      supplierSku: "Réf. fournisseur",
      quantity: "Qté",
      unitCost: "Coût unitaire",
      lineTotal: "Total",
      received: "Reçu",
      remaining: "Reste",
    },
    editor: {
      addLine: "Ajouter un article",
      addLinePlaceholder: "Rechercher un SKU ou un produit…",
      supplierPlaceholder: "Rechercher un fournisseur…",
      noLines: "Ajoutez les articles à commander.",
      removeLine: "Retirer la ligne",
      totalInCurrency: "Total en {currency}",
      totalInEuros: "Soit environ {amount}",
    },
    editHint: "Modifiable jusqu'à la clôture de la réception",
    resendOffer: "Commande modifiée après envoi : renvoyez la nouvelle version au fournisseur.",
    actions: {
      edit: "Modifier",
      pdf: "Aperçu PDF",
      resend: "Renvoyer au fournisseur",
      send: "Envoyer au fournisseur",
      markSent: "Marquer comme envoyée",
      confirm: "Marquer confirmée",
      cancel: "Annuler la commande",
      receive: "Réceptionner",
      addPayment: "Ajouter un paiement",
      deletePayment: "Supprimer le paiement",
      createOrder: "Créer la commande",
    },
    cancelTitle: "Annuler cette commande fournisseur ?",
    cancelBody: "Les quantités ne seront plus comptées comme à recevoir dans le stock.",
    overdue: "En retard",
    sections: {
      lines: "Articles",
      supplier: "Fournisseur",
      payments: "Paiements",
      receipts: "Réceptions",
      activity: "Historique",
    },
    noPayments: "Aucun paiement enregistré.",
    noReceipts: "Aucune réception pour l'instant.",
    receiptLine: "{count, plural, one {# article} other {# articles}} — {value}",
    receipt: {
      title: "Réception",
      description: "Les quantités reçues entrent en stock et mettent à jour le coût moyen.",
      date: "Date de réception",
      all: "Tout recevoir",
      none: "Tout remettre à zéro",
      submit: "Valider la réception",
      done: "Réception enregistrée",
      nothing: "Saisissez au moins une quantité reçue.",
    },
    payment: {
      title: "Paiement fournisseur",
      kind: "Nature",
      amount: "Montant",
      date: "Date du paiement",
      reference: "Référence",
      bankAccount: "Banque",
      bankAccountHint: "Ajoutez vos comptes dans Réglages › Achats pour les choisir dans une liste.",
      added: "Paiement enregistré",
      deleted: "Paiement supprimé",
      kinds: { deposit: "Acompte", balance: "Solde", transport: "Transport", other: "Autre" },
    },
    replenish: {
      badge: "Réappro auto",
      refresh: "Mettre à jour maintenant",
      updated: "{lines} ligne(s) mise(s) à jour sur {orders} brouillon(s)",
      upToDate: "Les brouillons de réappro sont à jour",
      bannerTitle: "Brouillon de réappro automatique",
      bannerBody:
        "Les articles passés sous leur seuil d'alerte s'ajoutent ici d'eux-mêmes, chaque heure, jusqu'à l'envoi. Les lignes que vous modifiez ne sont plus touchées et un article retiré ne revient pas. Rien n'est envoyé au fournisseur sans vous.",
      rateHint: "Commande en devise : vérifiez le taux de change avant d'envoyer (repris de la dernière commande).",
      intro:
        "Un brouillon de commande par fournisseur se remplit tout seul avec les articles sous leur seuil d'alerte, pour grouper les commandes et le transport.",
      seeDrafts: "Voir les brouillons de réappro",
    },
    suggestions: {
      intro:
        "Articles au niveau ou sous leur seuil, en tenant compte des commandes déjà passées. La quantité proposée ramène au stock cible.",
      emptyTitle: "Rien à réapprovisionner",
      emptyBody: "Tous les articles suivis sont au-dessus de leur seuil d'alerte.",
      noSupplier: "Sans fournisseur principal",
      noSupplierHint: "Définissez le fournisseur principal de ces articles pour pouvoir les commander.",
      leadTime: "Délai {days, plural, one {# jour} other {# jours}}",
      available: "Disponible",
      incoming: "À recevoir",
      reorderPoint: "Seuil",
      target: "Cible",
      suggested: "À commander",
      lastCost: "Coût moyen",
      openProduct: "Ouvrir la fiche produit",
      priceHint: "Vérifiez les prix d'achat dans la devise du fournisseur avant l'envoi.",
      rateLabel: "Taux (1 {currency} en €)",
    },
  },
  documents: {
    simulatedLabel: {
      title: "ÉTIQUETTE DE TEST",
      notice: "Simulation : aucune étiquette n'a été générée chez La Poste. Ne pas coller sur un colis.",
      reference: "Référence : {reference}",
      weight: "Poids : {weight} g",
    },
    eori: "EORI {number}",
    quote: "Devis",
    invoice: "Facture",
    creditNote: "Avoir",
    deliveryNote: "Bon de livraison",
    purchaseOrder: "Commande fournisseur",
    draft: "Brouillon",
    number: "N° {number}",
    issueDate: "Date : {date}",
    validUntil: "Valable jusqu'au {date}",
    dueDate: "Échéance : {date}",
    orderRef: "Commande {number}",
    reference: "Votre référence : {reference}",
    customerOrder: "Votre commande n° {number}",
    engagement: "N° d'engagement : {number}",
    corrects: "Avoir sur la facture {number}",
    deposit: "Facture d'acompte",
    depositMeta: "Acompte de {share} sur {document}",
    depositVatNote: "Facture d'acompte : la TVA est exigible à l'encaissement.",
    vatExemption: {
      intraCommunity: "Exonération de TVA, article 262 ter, I du CGI : livraison intracommunautaire.",
      export: "Exonération de TVA, article 262 I du CGI : exportation hors de l'Union européenne.",
      exempt: "Opération exonérée de TVA.",
    },
    finalAfterDeposit: "Facture définitive après acompte",
    depositDeducted: "Acompte déjà facturé — {number} du {date}",
    billTo: "Facturé à",
    shipTo: "Livré à",
    returnFrom: "Retour de",
    supplier: "Fournisseur",
    sku: "Réf.",
    designation: "Désignation",
    quantity: "Qté",
    unitPrice: "P.U. HT",
    discount: "Remise",
    vat: "TVA",
    amount: "Montant HT",
    subtotal: "Sous-total HT",
    globalDiscount: "Remise globale",
    shipping: "Frais de port",
    totalNet: "Total HT",
    vatLine: "TVA {rate} sur {base}",
    totalGross: "Total TTC",
    paid: "Déjà réglé",
    balanceDue: "Reste à payer",
    paymentTerms: "Paiement à {days, plural, =0 {réception} one {# jour} other {# jours}}, au plus tard le {date}.",
    noEarlyDiscount: "Pas d'escompte pour paiement anticipé.",
    latePenaltyPro:
      "En cas de retard de paiement : pénalités au taux de trois fois le taux d'intérêt légal et indemnité forfaitaire de 40 € pour frais de recouvrement (art. L441-10 du Code de commerce).",
    latePenaltyConsumer:
      "En cas de retard de paiement, des pénalités au taux de trois fois le taux d'intérêt légal pourront être appliquées.",
    bank: "Règlement par virement : IBAN {iban} — BIC {bic}",
    acceptance: "Bon pour accord — date, signature et cachet :",
    goodsNature: "Livraison de biens",
    legal: "{legalName} ({tradeName}) — {legalForm} au capital de {capital} — {rcs} — TVA {vat}",
    page: "Page {page} / {pages}",
    siret: "SIRET {siret}",
    vatNumber: "TVA {vat}",
    chorus: "Service {code}",
    thanks: "Merci de votre confiance.",
    signature: "Réception conforme — date et signature :",
    siren: "SIREN {siren}",
    subject: "Objet",
    deliveryTime: "Délai : {value}",
    watermark: { draft: "Brouillon", preview: "Aperçu" },
    sample: {
      customer: "Société Exemple SAS",
      address: "12 rue de la Paix",
      reference: "Appel d'offres 2026-07",
      subject: "Équipement de 12 agents de sécurité",
      deliveryTime: "3 semaines après acceptation",
      supplier: "Fournisseur Exemple GmbH",
      line1: "Plaque balistique NIJ IV — 25 × 30 cm",
      line1Description: "Céramique et polyéthylène, 2,6 kg, certification NIJ 0101.06.",
      line2: "Gilet porte-plaques tactique — taille L",
      line3: "Personnalisation : marquage du logo",
      notes: "Offre valable pour la quantité indiquée. Formation à la mise en place incluse.",
    },
    expectedAt: "Livraison souhaitée : {date}",
    email: {
      purchaseDocumentSubject: "{kind} — {name} — {company}",
      quoteSubject: "Devis {number} — {company}",
      quoteBody:
        "Bonjour,\n\nVeuillez trouver ci-joint notre devis {number}, valable jusqu'au {date}.\n\nNous restons à votre disposition pour toute question.\n\nCordialement,\n{company}",
      invoiceSubject: "Facture {number} — {company}",
      invoiceBody:
        "Bonjour,\n\nVeuillez trouver ci-joint la facture {number} d'un montant de {amount}, à régler avant le {date}.\n\nCordialement,\n{company}",
      creditNoteSubject: "Avoir {number} — {company}",
      creditNoteBody:
        "Bonjour,\n\nVeuillez trouver ci-joint l'avoir {number} d'un montant de {amount}.\n\nCordialement,\n{company}",
      purchaseOrderSubject: "Commande {number} — {company}",
      purchaseOrderBody:
        "Bonjour,\n\nVeuillez trouver ci-joint notre commande {number}. Merci de nous confirmer les quantités et le délai de livraison.\n\nCordialement,\n{company}",
      accountingSubject: "{kind} {number} — {company}",
    },
  },
  imports: {
    shopifySync: {
      title: "Synchro Shopify",
      body: "Récupère tout de suite les commandes et les stocks Shopify, sans attendre la synchro automatique (toutes les 15 minutes).",
    },
    iabakoSync: {
      title: "Synchroniser IABAKO",
      body: "Lit les devis et ventes créés ou modifiés dans IABAKO et montre ce qui sera repris. Rien n'est écrit avant « Appliquer ». IABAKO n'est jamais modifié.",
      read: "Lire IABAKO",
      reading: "Lecture d'IABAKO en cours. Cela prend quelques minutes, vous pouvez quitter la page.",
      readAt: "Lu le {date}.",
      appliedAt: "Appliqué le {date}.",
      unchanged:
        "{count, plural, =0 {} one {# document déjà identique dans l'ERP.} other {# documents déjà identiques dans l'ERP.}}",
      expired: "La dernière lecture a été remplacée ou n'est plus valable. Relancez la lecture.",
      upToDate: "L'ERP est à jour : rien à reprendre.",
      toApply: "À reprendre",
      actions: { create: "Nouveau", update: "Mis à jour", unchanged: "Inchangé" },
      newCustomers: "Clients qui seront créés",
      newCustomersHint: "Si l'un d'eux existe déjà dans l'ERP sous un autre nom, choisissez-le : le document y sera rattaché.",
      linkCustomer: "Rattacher à un client existant…",
      linkCustomerFor: "Client ERP de {name}",
      unresolved: "À résoudre (non repris)",
      reasons: {
        unknownArticle: "Article IABAKO « {detail} » inconnu de l'ERP.",
        ambiguousArticle: "Article IABAKO « {detail} » : plusieurs articles ERP possibles.",
        unreadable: "Document illisible ({detail}) : à reprendre à la main.",
        unknownStatus: "Statut IABAKO non reconnu : à vérifier à la main.",
        missingSourceQuote: "Le devis d'origine {detail} n'est pas dans l'ERP.",
        creditNote: "Avoir ou document d'un autre type ({detail}) : à rapprocher à la main.",
        payments: "Plusieurs règlements dans IABAKO : à saisir à la main.",
        totalGap: "Le total recalculé diffère d'IABAKO (en centimes : IABAKO/ERP {detail}).",
      },
      linkArticle: "Lier à un article ERP…",
      linkArticleFor: "Article ERP pour « {label} »",
      noArticle: "Ligne sans article",
      gaps: "Totaux différents d'IABAKO : {numbers}. L'application est bloquée.",
      stale: "Aperçu de plus de 30 minutes : relancez la lecture.",
      apply: "{count, plural, one {Appliquer (# document)} other {Appliquer (# documents)}}",
      applied: "Documents IABAKO repris dans l'ERP",
    },
    title: "Importer des données",
    subtitle: "CSV ou Excel exporté depuis IABAKO ou un tableur.",
    target: "Type de données",
    targets: {
      customers: "Clients",
      suppliers: "Fournisseurs",
      products: "Produits",
      documents: "Devis et factures (archives)",
    },
    dropzone: "Déposez un fichier ici ou cliquez pour parcourir",
    mapping: "Correspondance des colonnes",
    mappingHint: "Associez chaque colonne du fichier à un champ de l'ERP.",
    ignore: "Ignorer cette colonne",
    preview: "Aperçu",
    steps: {
      file: "Fichier",
      mapping: "Colonnes",
      preview: "Vérification",
      report: "Résultat",
    },
    csvOnly: "Formats acceptés : Excel (.xlsx, première feuille) ou CSV (séparateur virgule ou point-virgule).",
    fileError: "Ce fichier n'a pas pu être lu. Enregistrez-le au format .xlsx ou CSV UTF-8 puis réessayez.",
    emptyFile: "Ce fichier ne contient aucune ligne de données.",
    fileSummary:
      "{name} — {count, plural, one {# ligne} other {# lignes}}, {columns, plural, one {# colonne} other {# colonnes}}",
    changeFile: "Changer de fichier",
    column: "Colonne du fichier",
    field: "Champ de l'ERP",
    sample: "Exemple",
    missingRequired: "Associez les champs obligatoires : {fields}",
    duplicates: "Lignes déjà présentes dans l'ERP",
    duplicateModes: {
      skip: "Les ignorer",
      update: "Mettre à jour les fiches existantes",
    },
    duplicateHints: {
      customers: "Un client est reconnu par son e-mail, sinon par son SIRET.",
      suppliers: "Un fournisseur est reconnu par son nom.",
      products:
        "Un produit est reconnu par son SKU ; seuls prix, coût, EAN, poids, seuils et fournisseur sont mis à jour. Le stock initial n'est saisi que pour un article sans historique. « Nouvelle référence » renomme le SKU ; « Composition » (REF-A + 2 x REF-B) remplace les composants.",
      documents:
        "Un document est reconnu par son type et son numéro. Les archives restent en lecture seule : elles n'entrent ni dans la numérotation, ni dans le stock, ni dans la comptabilité. Le client est retrouvé par son e-mail, sinon par son nom.",
    },
    check: "Vérifier",
    checking: "Vérification…",
    summary: {
      created: "{count, plural, =0 {Aucune création} one {# création} other {# créations}}",
      updated: "{count, plural, =0 {Aucune mise à jour} one {# mise à jour} other {# mises à jour}}",
      skipped: "{count, plural, =0 {Aucun doublon ignoré} one {# doublon ignoré} other {# doublons ignorés}}",
      renamed: "{count, plural, one {# référence renommée} other {# références renommées}}",
      compositions: "{count, plural, one {# composition définie} other {# compositions définies}}",
      errors: "{count, plural, =0 {Aucune erreur} one {# ligne en erreur} other {# lignes en erreur}}",
    },
    status: {
      new: "Nouveau",
      duplicate: "Doublon",
      invalid: "Erreur",
    },
    line: "Ligne {line}",
    previewHint: "Les lignes en erreur ne seront pas importées. Corrigez le fichier puis rechargez-le pour les inclure.",
    previewMore: "… et {count, plural, one {# autre ligne} other {# autres lignes}}",
    imported: "Import terminé",
    restart: "Importer un autre fichier",
    kindValues:
      "Type détecté : « professionnel », « société » → professionnel ; « administration », « mairie », « police » → administration ; sinon particulier.",
    fields: {
      kind: "Type de client",
      companyName: "Société",
      firstName: "Prénom",
      lastName: "Nom",
      name: "Nom",
      contactName: "Contact",
      email: "E-mail",
      phone: "Téléphone",
      siret: "SIRET",
      vatNumber: "N° de TVA",
      chorusServiceCode: "Code service Chorus Pro",
      paymentTermsDays: "Délai de paiement (jours)",
      line1: "Adresse",
      line2: "Complément d'adresse",
      postalCode: "Code postal",
      city: "Ville",
      country: "Pays",
      website: "Site web",
      currency: "Devise",
      leadTimeDays: "Délai d'approvisionnement (jours)",
      notes: "Notes",
      sku: "SKU",
      title: "Désignation",
      productType: "Catégorie",
      ean: "EAN",
      weightGrams: "Poids (g)",
      salePrice: "Prix de vente HT",
      salePriceGross: "Prix de vente TTC",
      cost: "Coût d'achat HT",
      vatRate: "TVA (%)",
      reorderPoint: "Seuil d'alerte",
      targetStock: "Stock cible",
      supplier: "Fournisseur principal",
      initialStock: "Stock initial",
      newSku: "Nouvelle référence",
      composition: "Composition",
      docKind: "Type (devis, facture, avoir)",
      docNumber: "Numéro",
      docDate: "Date",
      customer: "Client",
      net: "Total HT",
      vat: "TVA",
      gross: "Total TTC",
      paid: "Montant réglé",
      status: "Statut",
    },
    run: "Importer {count, plural, one {# ligne} other {# lignes}}",
    done: "{created, plural, =0 {Aucune création} one {# création} other {# créations}}, {skipped, plural, =0 {aucun doublon} one {# doublon ignoré} other {# doublons ignorés}}, {failed, plural, =0 {aucune erreur} one {# erreur} other {# erreurs}}",
  },
  stockAlerts: {
    subject: "{company} : {count, plural, one {# article} other {# articles}} à réapprovisionner",
    intro:
      "{count, plural, one {# article est passé sous son seuil d'alerte} other {# articles sont passés sous leur seuil d'alerte}} (commandes fournisseurs en cours comprises) :",
    noSupplier: "Sans fournisseur principal",
    line: "  • {sku} {label} — disponible {available}, en commande {incoming}, seuil {threshold} → commander {suggested}",
    cta: "Préparer les commandes fournisseurs : {url}",
  },
  printing: {
    sent: "Envoyé à l'imprimante « {printer} » ({agent}).",
    labelAuto: "L'étiquette sort directement sur l'imprimante.",
    kinds: {
      label: "Étiquette",
      shipment_delivery_note: "Bon de livraison",
      order_delivery_note: "Bon de livraison (préparation)",
    },
    statuses: { pending: "En attente", printing: "En cours", done: "Imprimé", failed: "Échec" },
    agents: {
      title: "Ordinateurs d'impression",
      description:
        "Un petit programme (l'agent) tourne sur l'ordinateur relié à l'imprimante et imprime ce que l'ERP lui envoie, sans fenêtre ni clic. Un ordinateur = un agent.",
      empty: "Aucun ordinateur n'est encore relié.",
      add: "Relier un ordinateur",
      addDescription: "Donnez-lui un nom parlant ; vous recevrez ensuite le jeton à saisir sur cet ordinateur.",
      create: "Créer le jeton",
      name: "Nom de l'ordinateur",
      nameHint: "Par exemple « PC entrepôt » ou « Mac de Yannick ».",
      download: "Télécharger l'agent",
      downloadHint: "Un seul fichier, rien à installer : posez-le sur l'ordinateur relié à l'imprimante.",
      platforms: {
        windows: "Windows",
        "macos-apple-silicon": "macOS (Apple Silicon, M1 et suivants)",
        "macos-intel": "macOS (Intel)",
        linux: "Linux",
      },
      online: "En ligne",
      offline: "Hors ligne",
      printers: "Imprimantes : {list}",
      noPrinter: "Aucune imprimante vue par l'agent.",
      neverSeen: "L'agent ne s'est jamais connecté.",
      lastSeen: "vu le {date}",
      removed: "Ordinateur retiré.",
      removeTitle: "Retirer « {name} » ?",
      removeBody: "Son jeton cessera de fonctionner immédiatement et ses impressions en attente seront abandonnées.",
    },
    token: {
      title: "Jeton de « {name} »",
      description: "À faire une fois sur l'ordinateur relié à l'imprimante.",
      step1:
        "Téléchargez l'agent d'impression ci-dessous (un seul fichier, rien à installer) et posez-le sur cet ordinateur, par exemple dans Documents.",
      step2: "Ouvrez un terminal (macOS : Terminal ; Windows : PowerShell) et lancez cette commande :",
      step3:
        "Lancez ensuite « erp-print-agent » : il reste ouvert et l'ordinateur apparaît « En ligne » ici dans les secondes qui suivent.",
      step4: "Choisissez ci-dessous l'imprimante des étiquettes et celle des bons de livraison, puis enregistrez.",
      onceWarning: "Ce jeton n'est affiché qu'une fois. S'il est perdu, retirez l'ordinateur et reliez-le à nouveau.",
      copied: "Copié",
      copyFailed: "Impossible de copier : sélectionnez la commande et copiez-la à la main.",
    },
    routes: {
      title: "Où imprimer",
      description:
        "Pour chaque document, l'ordinateur et l'imprimante qui le sortent sans clic. « Navigateur » garde la fenêtre d'impression habituelle. Si l'ordinateur est hors ligne au moment d'expédier, l'ERP revient au navigateur.",
      label: "Étiquettes transporteur",
      deliveryNote: "Bons de livraison",
      printer: "Imprimante",
      browser: "Navigateur (fenêtre d'impression)",
      pickPrinter: "Choisir une imprimante",
      noPrinterYet: "L'agent n'a encore signalé aucune imprimante : lancez-le sur l'ordinateur, la liste se remplit toute seule.",
      noAgent: "Reliez d'abord un ordinateur ci-dessus.",
    },
    jobs: {
      title: "Dernières impressions",
      description:
        "Ce qui a été envoyé aux imprimantes, avec le résultat. Un échec est réessayé trois fois puis signalé dans Santé.",
      empty: "Rien n'a encore été imprimé par un agent.",
    },
  },
  settings: {
    title: "Réglages",
    groups: {
      account: "Mon compte",
      company: "Entreprise",
      sales: "Ventes",
      catalog: "Catalogue et stock",
      purchasing: "Achats",
      logistics: "Logistique et SAV",
      admin: "Administration",
    },
    pages: {
      account: { title: "Profil et sécurité" },
      company: {
        title: "Identité",
        subtitle:
          "Raison sociale, coordonnées, banque et logo : repris sur les devis, factures, commandes fournisseurs et le Factur-X.",
      },
      documents: { title: "Documents" },
      sales: {
        title: "Devis et factures",
        subtitle: "Valeurs par défaut des devis et factures, acomptes, factures des commandes du site et envoi au comptable.",
      },
      families: { title: "Familles" },
      purchasing: { title: "Achats", subtitle: "Comptes bancaires proposés à la saisie d'un paiement fournisseur." },
      stock: { title: "Stock", subtitle: "Suivi des articles par numéro de série, de la réception à l'expédition." },
      shipping: {
        title: "Expédition",
        subtitle:
          "Cartons en stock, poids moyens par famille et format La Poste par défaut : de quoi peser et décrire chaque colis.",
      },
      printing: {
        title: "Impression",
        subtitle:
          "Étiquettes et bons de livraison qui sortent de l'imprimante sans clic, grâce à un agent installé sur l'ordinateur relié à l'imprimante.",
      },
      sav: {
        title: "SAV",
        subtitle: "Motifs proposés à l'ouverture d'un dossier et délai au-delà duquel un dossier ouvert est signalé.",
      },
      users: { title: "Utilisateurs" },
      integrations: { title: "Intégrations" },
      imports: { title: "Imports" },
      activity: {
        title: "Journal d'activité",
        subtitle: "Les dernières modifications faites dans l'ERP, par tous les utilisateurs.",
      },
      health: { title: "Santé" },
    },
    salesSections: { quotes: "Devis", invoices: "Factures et avoirs", deposits: "Acomptes", orders: "Commandes" },
    savAlert: "Alerte",
    paymentAccounts: "Comptes de paiement",
    paymentAccountsHint:
      "Les comptes d'où partent les paiements fournisseurs (banque, carte…). Le premier est proposé par défaut ; chaque paiement garde le compte utilisé.",
    paymentAccountsEmpty: "Aucun compte : la banque se saisit librement sur chaque paiement.",
    paymentAccount: "Compte",
    paymentAccountDefault: "Compte par défaut",
    paymentAccountPlaceholder: "Qonto, carte bancaire…",
    paymentAccountAdd: "Ajouter un compte",
    documentsSubtitle:
      "Mise en page et textes par défaut des devis, factures, avoirs, bons de livraison et commandes fournisseurs. L'aperçu se met à jour à chaque changement.",
    sections: "Sections des réglages",
    readOnly: "Seul un administrateur peut modifier ces réglages.",
    webInvoiceModes: {
      external: "Émises dans Shopify (Simple Invoice)",
      erp: "Émises par l'ERP automatiquement",
      manual: "Émises par l'ERP à la main",
    },
    webInvoiceModeHints: {
      external:
        "La facture imprimée par Simple Invoice fait foi : l'ERP l'enregistre sous le numéro de commande Shopify dès que la commande est payée, sans numéro FAC ni PDF. Les remboursements Shopify y ajoutent un avoir.",
      erp: "Chaque commande payée sur le site est facturée, émise et marquée réglée sans intervention, avec un numéro FAC.",
      manual: "Rien n'est automatique : chaque commande du site est facturée depuis sa fiche, comme les autres.",
    },
    autoReplenishHint:
      "Tient à jour un brouillon de commande par fournisseur principal avec les articles sous leur seuil d'alerte. Rien n'est envoyé automatiquement.",
    replenishTitle: "Réapprovisionnement",
    creditNoteEngagementHint:
      "Décoché, un avoir ne reprend pas le numéro d'engagement de la facture (ni sur le PDF ni dans le Factur-X). Le numéro de bon de commande reste.",
    savReasons: "Motifs SAV",
    savReturnAddress: "Adresse de retour",
    savExchangeEmailTitle: "Étiquettes retour",
    savExchangeEmailHint:
      "L'étiquette retour part dans le colis du nouvel article lors d'un échange ; elle peut aussi être envoyée au client par e-mail. Chaque étiquette envoyée par e-mail peut être copiée à l'adresse de l'entreprise pour l'imprimer tout de suite.",
    savExchangeEmail: "Envoyer aussi l'étiquette retour au client par e-mail lors d'un échange",
    savLabelCopy: "Envoyer une copie des étiquettes retour à l'adresse e-mail de l'entreprise",
    savReturnAddressHint:
      "Destinataire des étiquettes retour (par exemple le bureau de poste de Chambly où vous retirez les colis). Vide : l'adresse de l'entreprise. Modifiable colis par colis.",
    savReasonsHint:
      "Les motifs proposés à l'ouverture d'un dossier, en plus des motifs intégrés. Chacun ouvre un dossier SAV, un échange ou un retour.",
    savReasonsBuiltIn:
      "Motifs intégrés : Défaut, Endommagé au transport, Erreur d'article, Échange de taille, Rétractation, Autre.",
    savReasonLabel: "Motif",
    savReasonNew: "motif",
    savReasonAdd: "Ajouter un motif",
    serialTrackingHint:
      "Coché, chaque réception, expédition, sortie, retour SAV ou inventaire d'un produit suivi exige un numéro par unité ; les unités se retrouvent par ⌘K et sur la fiche article. Décoché, rien n'est demandé et les numéros déjà enregistrés restent consultables. Un produit suivi qui a du stock sans numéros doit d'abord être renseigné depuis sa fiche.",
    depositInvoicesHint:
      "Coché, l'acceptation d'un devis et la fiche commande proposent une facture d'acompte (type 386). La facture définitive reprend l'acompte réglé : sa base HT et sa TVA portent sur le reste dû, avec la référence de l'acompte (cas d'usage DGFiP n° 20-21). Prévenez le comptable avant d'activer.",
    marginAlertHint: "Un devis dont la marge passe sous ce seuil est signalé.",
    savAlertHint: "Au-delà, le dossier apparaît dans « À surveiller » sur le tableau de bord.",
    documentTemplate: {
      scope: "Réglages pour",
      scopeHint:
        "« Tous les documents » : les réglages communs. Un document précis peut avoir son propre en-tête, son tableau et ses blocs, et ses textes.",
      scopeCommon: "Tous les documents",
      ownSetting: "Réglage propre : {document}",
      afterTotal: "Texte après le total",
      afterTotalHint: "Imprimé juste sous les totaux (délais, conditions particulières…).",
      identity: "Identité visuelle",
      identityHint: "Logo, couleurs et polices de tous les documents.",
      logoSize: "Taille du logo",
      logoSizes: { sm: "Petit", md: "Moyen", lg: "Grand" },
      accent: "Couleur des titres",
      accentHint: "Nom commercial et titre du document. Bleu nuit par défaut.",
      textColor: "Couleur du texte",
      mutedColor: "Couleur des textes secondaires",
      colorDefault: "Par défaut",
      headingFont: "Police des titres",
      bodyFont: "Police du texte",
      fontHint: "Deux polices sont embarquées : Inter (sobre) et Jost (géométrique).",
      letterhead: "En-tête",
      letterheadHint: "Coordonnées imprimées sous le nom commercial. Les valeurs se règlent dans Réglages › Identité.",
      showEmail: "E-mail",
      showPhone: "Téléphone",
      showWebsite: "Site web",
      showSiren: "SIREN dans le pied de page",
      table: "Tableau des lignes",
      tableHint: "Colonnes du tableau des devis, factures et avoirs.",
      sku: "Référence article",
      skuModes: { inline: "Sous la désignation", column: "Colonne à part", hidden: "Masquée" },
      discount: "Colonne Remise",
      discountModes: { auto: "Si une ligne est remisée", always: "Toujours", never: "Jamais" },
      vat: "Colonne TVA",
      description: "Description sous la désignation",
      blocks: "Bas de page du document",
      blocksHint: "Ordre et présence des blocs imprimés sous les totaux.",
      blockNames: {
        notes: "Notes du document",
        payment: "Conditions de paiement (mentions légales, IBAN)",
        terms: "Conditions particulières",
        closing: "Formule de clôture",
        signature: "Bon pour accord (devis)",
      },
      quote: "Options des devis",
      showIban: "Rappeler l'IBAN sur les devis",
      signature: "Cadre « bon pour accord » sur les devis",
      texts: "Textes par défaut",
      textsHint: "Repris quand le document n'a pas les siens. Un texte vide n'est pas imprimé.",
      textsForLabel: "Textes du document",
      textsFor: {
        quote: "Devis",
        invoice: "Factures",
        creditNote: "Avoirs",
        deliveryNote: "Bons de livraison",
        purchaseOrder: "Commande fournisseur (français)",
        purchaseOrderEn: "Commande fournisseur (anglais)",
        quoteEn: "Devis (anglais)",
        invoiceEn: "Factures (anglais)",
        creditNoteEn: "Avoirs (anglais)",
        deliveryNoteEn: "Bons de livraison (anglais)",
      },
      englishTextsHint: "Imprimés pour un client en anglais. Un texte anglais laissé vide reprend le texte français.",
      creditNoteTextsHint: "Un texte laissé vide reprend celui des factures.",
      deliveryTermsHint: "Imprimé sous le tableau des articles.",
      intro: "Texte d'introduction",
      introHint: "Imprimé avant le tableau, après l'objet.",
      terms: "Conditions particulières",
      closing: "Formule de clôture",
      footer: "Pied de page",
      footerHint: "Mentions complémentaires en bas de chaque page ; remplace le pied de page commun.",
      sharedFooter: "Pied de page commun",
      sharedFooterEn: "Pied de page commun (anglais)",
      sharedFooterEnHint: "Pour un client ou un fournisseur en anglais ; vide = le pied de page français.",
      sharedFooterHint: "Sur tous les documents, sous les mentions légales : pénalités de retard, indemnité forfaitaire…",
      preview: "Aperçu",
      previewKind: "Document affiché",
      openPreview: "Ouvrir l'aperçu",
      previewError: "L'aperçu n'a pas pu être généré.",
      moveUp: "Monter",
      moveDown: "Descendre",
      show: "Imprimer ce bloc",
    },
    audit: "Journal d'activité",
    profile: "Mon profil",
    role: "Rôle",
    preferences: "Préférences",
    password: {
      title: "Mot de passe",
      description: "Choisissez un mot de passe personnel que vous n'utilisez nulle part ailleurs.",
      change: "Changer le mot de passe",
      rules: "12 caractères minimum. Une phrase de passe facile à retenir convient très bien.",
      current: "Mot de passe actuel",
      new: "Nouveau mot de passe",
      confirm: "Confirmez le nouveau mot de passe",
      revokeOthers: "Déconnecter mes autres appareils",
      wrongCurrent: "Mot de passe actuel incorrect.",
      changed: "Mot de passe modifié",
    },
    twoFactor: {
      title: "Vérification en deux étapes",
      description: "Un code de votre téléphone est demandé à chaque connexion sur un nouvel appareil.",
      enabled: "Activée",
      disabled: "Désactivée",
      enable: "Activer",
      disable: "Désactiver",
      password: "Confirmez votre mot de passe",
      scan: "Scannez ce QR code avec votre application d'authentification (Google Authenticator, 1Password…), puis saisissez le code affiché.",
      manualKey: "Clé à saisir manuellement",
      confirm: "Confirmer",
      enabledToast: "Vérification en deux étapes activée",
      disabledToast: "Vérification en deux étapes désactivée",
      backupCodes: "Codes de secours",
      backupHint: "Conservez ces codes en lieu sûr. Chacun permet une connexion si vous n'avez plus accès à votre téléphone.",
      done: "J'ai conservé mes codes",
    },
  },
  integrations: {
    title: "Intégrations",
    subtitle:
      "Connectez l'ERP à vos services. Les mots de passe et jetons sont chiffrés et ne sont plus jamais réaffichés après enregistrement.",
    active: "Connecté",
    missing: "À configurer",
    save: "Enregistrer",
    saved: "Réglages enregistrés",
    test: "Tester la connexion",
    testOk: "Connexion réussie",
    testOkDetail: "Connexion réussie : {detail}",
    testEmailTo: "Envoyer aussi un e-mail de test à {email}",
    secretSet: "Enregistré",
    secretEmpty: "Non renseigné",
    secretReplace: "Remplacer",
    secretRemove: "Supprimer",
    secretKeep: "Garder l'actuel",
    fromServer: "Valeur définie sur le serveur ; une valeur saisie ici la remplace.",
    optional: "Facultatif",
    unsaved: "Modifications non enregistrées",
    howTo: "Où trouver ces informations ?",
    lastSync: "Dernière synchronisation {date}",
    neverSynced: "Jamais synchronisé",
    failedWebhooks: "{count, plural, one {# notification Shopify en échec} other {# notifications Shopify en échec}}",
    syncNow: "Synchroniser maintenant",
    synced:
      "{orders, plural, =0 {Aucune commande à récupérer} one {# commande synchronisée} other {# commandes synchronisées}}, {linked, plural, =0 {stocks déjà reliés} one {# article relié au stock Shopify} other {# articles reliés au stock Shopify}}",
    webhookUrl: "Adresse de réception des webhooks",
    copy: "Copier",
    copied: "Adresse copiée",
    registerWebhooks: "Abonner Shopify aux commandes",
    webhooksRegistered: "{created, plural, =0 {Webhooks déjà en place} one {# webhook créé} other {# webhooks créés}}",
    locations: "Entrepôts Shopify",
    useLocation: "Utiliser",
    providers: {
      shopify: {
        name: "Shopify",
        description: "Commandes du site, stock, numéros de suivi et import du catalogue.",
        howTo:
          "Dans l'admin Shopify : Paramètres › Applications › Développer des applications › Créer une application. Accès Admin API : read/write_orders, read/write_inventory, read_products, read_locations, read/write_merchant_managed_fulfillment_orders. Après installation, copiez le jeton Admin API (shpat_…) et la clé secrète de l'API (pour les webhooks).",
      },
      email: {
        name: "Envoi d'e-mails",
        description: "Devis, factures et commandes fournisseurs envoyés depuis l'ERP.",
        howTo:
          "Paramètres SMTP de votre messagerie. Google Workspace : smtp.gmail.com, port 465 chiffré, identifiant = adresse complète, mot de passe d'application. OVH : ssl0.ovh.net, port 465.",
      },
      chronopost: {
        name: "Chronopost",
        description: "Étiquettes Chrono 13 (ou autre produit) et suivi des colis.",
        howTo:
          "Numéro de compte client Chronopost (8 chiffres) et mot de passe des Web Services, fournis par votre commercial Chronopost. Le suivi des colis Chronopost fonctionne même sans compte.",
      },
      colissimo: {
        name: "Colissimo",
        description: "Étiquettes aller, retour et réexpédition.",
        howTo:
          "Il faut un contrat Colissimo (Facilité ou supérieur) avec les Web Services activés : appelez le 3634 ou votre interlocuteur La Poste. Ensuite, dans la Colissimo Box : édition du profil › « Clés de connexion aux Web Services » › Générer, puis collez la clé ici avec le numéro de compte client (6 chiffres, à côté de la raison sociale). Le mot de passe ne sert qu'aux anciens raccordements, sans clé.",
      },
      laposte: {
        name: "La Poste — suivi des colis",
        description:
          "Livraison détectée automatiquement pour les colis Colissimo et courriers suivis, sans contrat Colissimo (étiquettes faites sur La Poste Pro Expédition, numéros saisis ou remontés par Shopify).",
        howTo:
          "Créez un compte gratuit sur developer.laposte.fr, puis une application (Mes applications › Créer une application). Abonnez-la à l'API « Suivi » (offre gratuite) et copiez la clé de production affichée sur l'application. Les colis expédiés sont vérifiés toutes les deux heures.",
      },
      chorus: {
        name: "Chorus Pro",
        description: "Dépôt automatique des factures destinées aux administrations.",
        howTo:
          "Sur piste.gouv.fr : créer une application et y associer l'API Chorus Pro (identifiant et secret OAuth). Sur chorus-pro.gouv.fr : créer un compte technique rattaché au SIRET. Commencez en mode qualification.",
      },
      iabako: {
        name: "IABAKO (ancien outil)",
        description: "Reprise des devis et ventes créés dans IABAKO jusqu'à la bascule, depuis Réglages › Imports.",
        howTo:
          "Le compte IABAKO avec lequel l'ERP se connecte pour lire les devis et les ventes. L'ERP ne fait que consulter : il n'enregistre jamais rien dans IABAKO. « Tester la connexion » ouvre puis ferme une session.",
      },
      inqom: {
        name: "Expert-comptable (Inqom)",
        description: "Chaque facture et avoir émis est transmis automatiquement, par l'API Inqom ou par e-mail.",
        howTo:
          "Deux possibilités. Par e-mail : l'adresse de collecte des factures de vente fournie par Inqom ou par le cabinet. Par l'API (dépôt direct dans le dossier, avec suivi) : demandez au cabinet un utilisateur Inqom dédié à l'ERP, le secret client de l'API et l'identifiant du dossier (le nombre dans l'adresse d'Inqom quand le dossier est ouvert). Commencez en bac à sable, puis décochez-le. Quand l'API est configurée, elle remplace l'e-mail.",
      },
    },
    fields: {
      shopify: {
        shopDomain: { label: "Domaine de la boutique", hint: "Adresse en .myshopify.com" },
        clientId: { label: "ID client de l'application", hint: "Dev Dashboard Shopify › Paramètres de l'application" },
        webhookSecret: {
          label: "Clé secrète de l'application",
          hint: "Commence par shpss_ ; sert à obtenir le jeton d'accès et à vérifier les webhooks",
        },
        adminToken: {
          label: "Jeton Admin API (ancienne app)",
          hint: "Commence par shpat_ ; remplace l'ID client s'il est rempli",
        },
        locationId: { label: "Entrepôt Shopify", hint: "Laisser vide pour utiliser l'entrepôt principal" },
        apiVersion: { label: "Version de l'API", hint: "Laisser la valeur par défaut sauf besoin" },
        publicUrl: { label: "Adresse du site", hint: "Utilisée pour importer le catalogue" },
        writeBack: {
          label: "Écrire dans Shopify",
          hint: "Envoie à la boutique le stock, les expéditions (avec e-mail au client), les remboursements SAV et les notes d'échange. À n'activer qu'en production, stock initial saisi",
        },
        syncExchanges: {
          label: "Signaler les échanges SAV sur la commande Shopify",
          hint: "Après l'envoi d'un échange : une ligne dans la note de la commande et l'étiquette « echange-sav ». Les articles, le paiement et la facture Shopify ne changent pas. Demande « Écrire dans Shopify » et l'accès write_orders",
        },
        pushPrices: {
          label: "Envoyer les prix à Shopify",
          hint: "Un prix de vente modifié dans l'ERP (fiche produit ou import) est envoyé à la variante Shopify, TVA comprise. Seul le prix est écrit. Indépendant de « Écrire dans Shopify ». Désactivé, le prix modifié reste en attente et l'ERP le garde. Demande l'accès write_products",
        },
      },
      email: {
        host: { label: "Serveur SMTP", hint: "" },
        port: { label: "Port", hint: "465 (chiffré) ou 587 (STARTTLS)" },
        secure: { label: "Connexion chiffrée (SSL/TLS)", hint: "À cocher pour le port 465" },
        user: { label: "Identifiant", hint: "" },
        password: { label: "Mot de passe", hint: "" },
        fromName: { label: "Nom de l'expéditeur", hint: "" },
        fromEmail: { label: "Adresse d'expédition", hint: "" },
        replyTo: {
          label: "Adresse de réponse",
          hint: "Où arrivent les réponses des clients. Par défaut : l'e-mail de la société",
        },
      },
      chronopost: {
        accountNumber: { label: "Numéro de compte", hint: "8 chiffres" },
        password: { label: "Mot de passe Web Services", hint: "" },
        productCode: { label: "Produit", hint: "01 Chrono 13 (par défaut), 02 Chrono 10, 16 Chrono 18" },
      },
      colissimo: {
        apiKey: {
          label: "Clé API (Colissimo Box › mon profil)",
          hint: "« Clés de connexion aux Web Services » dans l'édition du profil. Remplace le mot de passe",
        },
        contractNumber: {
          label: "Numéro de compte client",
          hint: "Les 6 chiffres affichés à côté de la raison sociale dans la Colissimo Box. Avec la clé API, Colissimo l'exige sur certains comptes (erreur 30008)",
        },
        password: { label: "Mot de passe Web Services", hint: "Ancienne méthode : inutile si la clé API est renseignée" },
      },
      laposte: {
        okapiKey: { label: "Clé API (X-Okapi-Key)", hint: "Clé de production de l'application, sur developer.laposte.fr" },
      },
      chorus: {
        clientId: { label: "Identifiant OAuth PISTE", hint: "" },
        clientSecret: { label: "Secret OAuth PISTE", hint: "" },
        techLogin: { label: "Identifiant du compte technique", hint: "" },
        techPassword: { label: "Mot de passe du compte technique", hint: "" },
        sandbox: { label: "Mode qualification (tests)", hint: "Décochez pour déposer les vraies factures" },
      },
      iabako: {
        email: { label: "E-mail de connexion IABAKO", hint: "" },
        password: { label: "Mot de passe IABAKO", hint: "" },
      },
      inqom: {
        collectionEmail: { label: "Adresse de collecte (e-mail)", hint: "Aussi modifiable dans Réglages › Devis et factures" },
        sandbox: { label: "Bac à sable Inqom (tests)", hint: "Décochez pour déposer dans le vrai dossier" },
        username: { label: "Utilisateur Inqom (API)", hint: "Adresse de connexion à Inqom de l'utilisateur dédié" },
        password: { label: "Mot de passe Inqom", hint: "" },
        clientId: { label: "Identifiant client de l'API", hint: "Fourni par Inqom avec le secret ; « Web » par défaut" },
        clientSecret: { label: "Secret client de l'API", hint: "Fourni par Inqom" },
        enterpriseId: { label: "Identifiant du dossier", hint: "Nombre, visible dans l'adresse d'Inqom" },
      },
    },
  },
  users: {
    title: "Utilisateurs",
    subtitle: "Les comptes sont créés ici ; personne ne peut s'inscrire seul.",
    new: "Nouvel utilisateur",
    edit: "Modifier l'utilisateur",
    empty: "Aucun utilisateur",
    you: "Vous",
    fields: {
      name: "Nom",
      email: "E-mail",
      role: "Rôle",
      password: "Mot de passe provisoire",
      status: "Accès",
      lastSeen: "Dernière activité",
      twoFactor: "Double authentification",
    },
    passwordHint: "12 caractères minimum. Transmettez-le par un canal sûr ; l'utilisateur le changera ensuite.",
    generate: "Générer",
    statuses: {
      active: "Actif",
      disabled: "Désactivé",
    },
    never: "Jamais connecté",
    roleHints: {
      admin: "Accès complet, y compris réglages et utilisateurs.",
      sales: "Clients, produits, devis, commandes, factures et SAV, imports et synchro Shopify. Consultation du reste.",
      logistics: "Stock, expéditions, achats, fournisseurs, produits et SAV. Consultation des clients et commandes.",
      accounting: "Consultation de tout et exports, sans rien modifier.",
    },
    actions: {
      edit: "Modifier",
      disable: "Désactiver l'accès",
      enable: "Réactiver l'accès",
      resetPassword: "Définir un mot de passe",
    },
    resetTitle: "Nouveau mot de passe pour {name}",
    resetHint: "Ses sessions ouvertes seront fermées.",
    disableTitle: "Désactiver l'accès de {name} ?",
    disableBody:
      "Ses sessions sont fermées immédiatement. L'historique de ses actions est conservé et l'accès peut être rétabli.",
    created: "Utilisateur créé",
    updated: "Utilisateur modifié",
    disabled: "Accès désactivé",
    enabled: "Accès réactivé",
    passwordSet: "Mot de passe mis à jour",
    copied: "Mot de passe copié",
  },
  integrity: {
    title: "Santé du logiciel",
    subtitle:
      "Contrôles automatiques des règles qui doivent toujours être vraies : numérotation, montants, stock. Ils tournent chaque jour dès 6 h ; les administrateurs sont prévenus par e-mail au moindre écart.",
    run: "Lancer le contrôle",
    running: "Contrôle en cours…",
    lastRun: "Dernier contrôle le {date}",
    never: "Aucun contrôle n'a encore tourné.",
    allGood: "Aucune incohérence : les {count, number} règles sont respectées.",
    issues: "{count, plural, one {# règle non respectée} other {# règles non respectées}}",
    occurrences: "{count, plural, one {# cas} other {# cas}}",
    worker: "Tâches automatiques",
    workerOk: "Actives (dernier signe de vie le {date})",
    workerStale: "Arrêtées depuis le {date} : synchronisation Shopify, e-mails et suivi des colis en pause.",
    workerNever: "Jamais démarrées.",
    backup: {
      title: "Sauvegardes",
      ok: "Restauration d'essai réussie le {date} : {count, plural, one {# facture émise retrouvée} other {# factures émises retrouvées}}.",
      failed: "Échec de la restauration d'essai le {date} : {detail}",
      never: "Aucune restauration d'essai pour l'instant : elle a lieu chaque dimanche matin.",
    },
    errors: {
      title: "Erreurs inattendues (30 derniers jours)",
      empty: "Aucune erreur inattendue.",
      seen: "{count, plural, one {# fois} other {# fois}}, dernière le {date}",
      sources: { api: "Serveur", web: "Navigateur", job: "Tâche automatique" },
    },
    errorDigest: {
      subject: "{company} : {count, plural, one {# erreur inattendue} other {# erreurs inattendues}} dans l'ERP",
      intro:
        "{count, plural, one {# erreur inattendue s'est produite} other {# erreurs inattendues se sont produites}} depuis le dernier message. Merci de transmettre ce message au support.",
      line: "  • [{source}] {message} — {where} ({count, plural, one {# fois} other {# fois}})",
    },
    email: {
      subject: "{company} : {count, plural, one {# incohérence détectée} other {# incohérences détectées}} dans l'ERP",
      intro:
        "Le contrôle de cette nuit a trouvé {count, plural, one {# règle non respectée} other {# règles non respectées}}. Rien n'a été modifié ; merci de transmettre ce message au support.",
      check: "{check} ({count, plural, one {# cas} other {# cas}}) :",
      cta: "Détail : {url}",
    },
    checks: {
      jobs_not_stuck_running: "Aucune tâche de fond « en cours » depuis plus de 30 minutes",
      jobs_not_left_waiting: "Aucune tâche de fond en attente depuis plus d'une heure après son heure prévue",
      invoice_numbering_gapless: "Numérotation des factures et avoirs sans trou ni doublon",
      invoice_numbering_matches_sequence: "Chaque numéro attribué correspond à un document émis",
      invoice_number_matches_date: "Préfixe et année du numéro conformes au document et à sa date",
      issued_invoice_has_number_and_date: "Documents émis numérotés et datés, brouillons sans numéro",
      invoice_paid_matches_payments: "Montant encaissé égal à la somme des paiements",
      invoice_not_overpaid: "Aucune facture encaissée au-delà de son montant",
      payments_only_on_issued_invoices: "Paiements uniquement sur des documents émis",
      credit_notes_within_invoice: "Avoirs inférieurs ou égaux à la facture d'origine",
      credit_lines_within_billed: "Aucune ligne de facture créditée au-delà de la quantité facturée",
      credit_note_corrects_an_issued_invoice: "Chaque avoir corrige une facture émise",
      order_line_quantities_in_range: "Quantités expédiées et facturées dans les limites commandées",
      order_allocations_on_open_orders: "Stock réservé seulement sur des commandes à traiter ou en préparation",
      order_kit_lines_match_shopify_line:
        "Lignes d'un kit Shopify éclaté : des ensembles complets, en même nombre sur chaque article",
      order_line_invoiced_matches_invoices: "Quantités facturées égales aux lignes de facture",
      order_line_billed_within_quantity: "Aucune ligne de commande facturée au-delà de sa quantité, avoirs déduits",
      order_line_shipped_matches_parcels: "Quantités expédiées égales au contenu des colis",
      delivered_order_has_delivered_parcels: "Commandes livrées sans colis en attente",
      shipped_parcel_left_stock_once: "Chaque colis est sorti du stock exactement une fois",
      cancelled_parcel_back_in_stock: "Chaque colis annulé a rendu au stock exactement ce qu'il avait pris",
      stock_movement_direction: "Sens et coûts des mouvements de stock cohérents, y compris la trace des compositions",
      kit_has_no_stock_movements: "Aucun mouvement ni stock propre sur une composition",
      kit_components_are_not_kits: "Les composants d'une composition sont des articles physiques",
      quote_has_one_order: "Chaque devis accepté a donné exactement une commande",
      archived_article_has_no_stock: "Aucun stock sur un article archivé",
      purchase_line_received_in_range: "Quantités reçues dans les limites commandées aux fournisseurs",
      sav_line_received_in_range: "Réceptions SAV entre zéro et la quantité déclarée sur le dossier",
      sav_returns_within_received: "Pas plus d'unités revenues du client que reçues sur la commande (remplacements compris)",
      purchase_received_matches_receipts: "Quantités reçues des commandes fournisseurs égales aux entrées en stock",
      purchase_closed_has_invoice:
        "Commande fournisseur clôturée seulement avec sa facture, « facture à déposer » seulement sans",
      order_allocations_within_remaining: "Unités isolées dans la limite de ce qui reste à expédier",
      order_archived_only_when_finished: "Seules les commandes livrées ou annulées sont archivées",
      cancelled_count_has_no_movements: "Un inventaire annulé n'a rien passé en stock",
      resent_parcel_not_cancelled: "Un colis renvoyé n'est pas annulé tant que son renvoi existe",
      sav_credit_note_of_same_order: "Avoirs SAV rattachés à la bonne commande",
      invoice_refs_match_order:
        "N° d'engagement et de commande des factures identiques à ceux de la commande, ceux des avoirs à ceux de leur facture",
      no_job_failed_for_a_day: "Aucune tâche automatique en échec depuis plus d'un jour",
      shopify_order_not_archived: "Aucune commande Shopify de l'historique CSV reprise aussi comme commande de l'ERP",
      order_totals_match_lines: "Totaux enregistrés des commandes égaux à ceux de leurs lignes",
      external_document_of_shopify_order:
        "Documents émis dans Shopify rattachés à une commande du site, émis, sans PDF, avoirs du même émetteur que leur facture",
      external_invoice_unique_per_order: "Une seule facture Shopify par commande du site",
      order_not_invoiced_twice: "Aucune commande facturée à la fois dans Shopify et dans l'ERP",
      inqom_deposit_recorded: "Documents déposés chez Inqom avec leur identifiant et leur date de transmission",
      purchase_document_deposit_recorded: "Pièces d'achat déposées chez Inqom avec leur identifiant et leur date de transmission",
      deposit_deducted_within_amount: "Acomptes repris au plus une fois, dans la limite de leur montant",
      deposit_deducted_only_when_paid: "Seuls des acomptes émis et réglés sont repris sur une facture définitive",
      deposits_within_order: "Acomptes d'une commande inférieurs ou égaux à son montant",
      deposit_has_order: "Chaque facture d'acompte est liée à une commande, sans ligne de commande",
      serial_units_match_stock: "Unités en stock égales au stock physique des articles suivis par numéro de série",
      serial_shipment_lines_complete: "Colis d'articles suivis avec un numéro de série par unité",
      serial_status_consistent: "État des unités cohérent avec leurs documents",
      invoice_totals_match_lines: "Totaux des factures égaux au calcul des lignes",
      quote_totals_match_lines: "Totaux des devis égaux au calcul des lignes",
    },
  },
  audit: {
    title: "Journal d'activité",
    history: "Historique",
    changedFields: "{count, plural, one {# champ modifié} other {# champs modifiés}}",
    emptyTitle: "Aucune activité",
    actions: {
      create: "{actor} a créé {entity}",
      update: "{actor} a modifié {entity}",
      archive: "{actor} a archivé {entity}",
      restore: "{actor} a restauré {entity}",
      import: "{actor} a importé {entity}",
      delete: "{actor} a supprimé {entity}",
      cancel: "{actor} a annulé {entity}",
    },
    system: "Système",
  },
  confirms: {
    unsaved: {
      title: "Quitter sans enregistrer ?",
      body: "Les modifications de ce formulaire seront perdues.",
      confirm: "Quitter sans enregistrer",
    },
    quoteInvoice: {
      title: "Facturer ce devis ?",
      body: "Le devis passe « Accepté » : une commande est créée (le stock est réservé) et une facture brouillon est préparée. Le devis ne sera plus modifiable.",
      confirm: "Facturer",
    },
    quoteDecline: {
      title: "Marquer ce devis refusé ?",
      body: "Le devis est clos : il ne pourra plus être accepté ni modifié. Pour le reprendre, dupliquez-le.",
      confirm: "Marquer refusé",
    },
    quoteCancel: {
      title: "Annuler ce devis ?",
      body: "Le devis est clos : il ne pourra plus être accepté ni modifié. Pour le reprendre, dupliquez-le.",
      confirm: "Annuler le devis",
    },
    orderDelivered: {
      title: "Marquer la commande livrée ?",
      body: "La commande passe « Livrée » sans attendre le suivi du transporteur, et le délai d'archivage démarre. Ce n'est pas réversible.",
      confirm: "Marquer livrée",
    },
    shipmentDelivered: {
      title: "Marquer ce colis livré ?",
      body: "Le colis passe « Livré » sans attendre le suivi du transporteur. Si c'était le dernier colis de la commande, la commande passe aussi « Livrée ». Ce n'est pas réversible.",
      confirm: "Marquer livré",
    },
    orderFileRemove: {
      title: "Retirer ce fichier ?",
      body: "« {name} » est supprimé de la commande et ne sera plus joint aux factures déposées ensuite sur Chorus Pro.",
      confirm: "Retirer",
    },
    paymentsClear: {
      title: "Remettre en attente de paiement ?",
      body: "Les paiements enregistrés ({amount}) sont retirés : la facture redevient due en entier. Ils restent consultables dans le journal.",
      confirm: "Remettre en attente",
    },
    paymentRemove: {
      title: "Supprimer ce paiement ?",
      body: "Le paiement de {amount} est retiré : le reste à payer augmente d'autant.",
      confirm: "Supprimer le paiement",
    },
    chorusResubmit: {
      title: "Déposer à nouveau sur Chorus Pro ?",
      body: "La facture émise est déposée telle quelle, avec ses pièces jointes. Si elle a été rejetée, corrigez d'abord ce qui a causé le rejet (code service, numéro d'engagement) ; sinon établissez un avoir et une nouvelle facture.",
      confirm: "Redéposer",
    },
    savResolve: {
      title: "Résoudre ce dossier ?",
      repair:
        "Le dossier passe « Résolu » avec la mention réparation. Aucun mouvement de stock, aucun remboursement. Vous pourrez encore le rouvrir.",
      none: "Le dossier passe « Résolu » sans suite. Aucun mouvement de stock, aucun remboursement. Vous pourrez encore le rouvrir.",
      confirm: "Résoudre",
    },
    iabakoSync: {
      title: "Reprendre ces documents IABAKO ?",
      body: "{count, plural, one {# document sera créé ou mis à jour} other {# documents seront créés ou mis à jour}} dans l'ERP, exactement comme dans l'aperçu. Ils comptent dans le chiffre d'affaires. Rien n'est envoyé au client ni au comptable.",
      confirm: "Appliquer",
    },
    shopifySync: {
      title: "Synchroniser maintenant ?",
      body: "L'ERP relit tout de suite les commandes Shopify modifiées depuis la dernière synchro : nouvelles commandes créées, stock réservé, factures selon le mode du site. Cela se fait aussi tout seul toutes les 15 minutes.",
      confirm: "Synchroniser",
    },
    catalogImport: {
      title: "Importer le catalogue Shopify ?",
      body: "Les produits du site sont créés ou mis à jour : titre, famille, description, options, poids et prix sont réécrits depuis Shopify. SKU, seuils, coûts, fournisseurs et compositions de l'ERP ne sont pas touchés.",
      confirm: "Importer",
    },
    attachVariant: {
      title: "Rattacher la variante ?",
      body: "La variante quitte son produit pour le produit choisi, avec son stock et son historique.",
      confirm: "Rattacher",
    },
    splitVariants: {
      title: "Dissocier les variantes ?",
      body: "Les articles sont créés, le stock en main leur est transféré et chaque variante du site devient une composition. Ce n'est pas réversible.",
      confirm: "Dissocier",
    },
    userRole: {
      title: "Changer le rôle de {name} ?",
      body: "Le nouveau rôle ({role}) s'applique tout de suite et la personne est déconnectée de tous ses appareils.",
      confirm: "Changer le rôle",
    },
    stockExit: {
      title: "Retirer du stock ?",
      body: "{count, plural, one {# unité quitte} other {# unités quittent}} le stock sans colis, au coût moyen actuel. Une erreur se rattrape avec « Corriger le stock ».",
      confirm: "Retirer du stock",
    },
    inventoryCancel: {
      title: "Annuler cet inventaire ?",
      body: "Les quantités comptées sont abandonnées et rien n'est écrit dans le stock. Un inventaire annulé ne se reprend pas : il faudra en commencer un autre.",
      confirm: "Annuler l'inventaire",
    },
    serialDisable: {
      title: "Ne plus suivre ce produit par numéro de série ?",
      body: "Les réceptions, expéditions et retours ne demanderont plus de numéros pour ce produit. Les numéros déjà enregistrés restent dans l'historique.",
      confirm: "Désactiver le suivi",
    },
    typeTrackingOn: {
      title: "Suivre tous les produits « {type} » ?",
      body: "Chaque réception, expédition et retour de ces {count, plural, one {# produit} other {# produits}} demandera les numéros de série. Tout est refusé si l'un d'eux ne peut pas être suivi (par exemple un composant de kit) ; le message nomme le produit en cause.",
      confirm: "Suivre tout le type",
    },
    typeTrackingOff: {
      title: "Ne plus suivre les produits « {type} » ?",
      body: "Ces {count, plural, one {# produit} other {# produits}} ne demanderont plus de numéros de série. Les numéros déjà enregistrés restent dans l'historique.",
      confirm: "Ne plus suivre",
    },
    logoRemove: {
      title: "Revenir au logo Phygiatech ?",
      body: "Le logo importé est supprimé : les prochains devis, factures et bons de commande porteront le logo Phygiatech. Les documents déjà émis ne changent pas. Pour le retrouver, il faudra réimporter le fichier.",
      confirm: "Revenir au logo Phygiatech",
    },
  },
  help: {
    ui: {
      title: "Aide",
      subtitle:
        "Comment fonctionne l'ERP, workflow par workflow : ce que fait chaque action, ce qu'elle modifie et ce qui part à l'extérieur.",
      search: "Rechercher dans l'aide (ex. remboursement, étiquette, acompte)",
      noResult: "Aucun passage ne correspond.",
      contents: "Sur cette page",
      about: "Ce que fait cette action",
      more: "En savoir plus ›",
    },
    quote: {
      preview:
        "Dessine le PDF avec les valeurs en cours, même non enregistrées, avec un filigrane « Aperçu ». Rien n'est enregistré ni envoyé.",
      send: "Envoie le devis en PDF par e-mail au client. Une fois parti, le devis passe « Envoyé » et son PDF est figé. Un e-mail envoyé ne se rattrape pas.",
      accept:
        "Transforme le devis en commande : la commande est créée, le stock est réservé et le devis passe « Accepté » définitivement. Peut enregistrer les références (bon de commande, Chorus) et créer un acompte.",
      invoice:
        "Accepte d'abord le devis s'il ne l'est pas (commande créée, stock réservé, sans retour possible), puis prépare une facture brouillon. Rien n'est émis tant que vous ne cliquez pas « Émettre ».",
      duplicate:
        "Crée un nouveau devis brouillon, numéroté, avec les mêmes lignes, daté d'aujourd'hui. L'original ne change pas.",
      decline:
        "Clôt le devis définitivement (refusé ou annulé). Il ne pourra plus être accepté ni modifié ; pour le reprendre, dupliquez-le.",
    },
    order: {
      allocate:
        "Réserve le stock des lignes cochées pour cette commande, avant toute autre (même plus ancienne ou urgente). La commande passe « Prête » quand tout est couvert. La réservation est consommée à l'expédition, levée à l'annulation. Réversible (« Libérer »).",
      prepare:
        "Ouvre le bon de livraison à imprimer et passe la commande « En préparation ». Rien ne sort du stock à cette étape.",
      deliveryNote:
        "PDF des lignes restant à expédier, à imprimer en deux exemplaires (un laissé, un signé). Rien n'est enregistré.",
      urgent: "Met la commande en tête des listes et la sert en priorité sur le stock disponible. Réversible à tout moment.",
      delivered:
        "Passe la commande « Livrée » sans toucher aux colis. Normalement automatique grâce au suivi transporteur ; démarre le délai d'archivage. Irréversible.",
      cancel:
        "Annule la commande et libère le stock réservé. N'annule rien dans Shopify, ni les factures ou acomptes existants. Irréversible.",
      archive: "Range la commande dans « Archivées » (fait automatiquement après le délai réglé). Réversible.",
      invoice:
        "Prépare une facture brouillon avec ce qui n'est pas encore facturé (port sur la première facture). La commande quitte la vue « À facturer ». Supprimer le brouillon annule tout.",
      deposit:
        "Prépare une facture d'acompte brouillon (un pourcentage ou un montant) : une ligne par taux de TVA. Numérotée à l'émission, puis déduite de la facture finale.",
      publicRefs:
        "Numéro d'engagement, SIRET, code service, bon de commande et BL signé : repris sur les factures brouillon et joints au Factur-X envoyé à Chorus Pro. Verrouillés dès qu'une facture ou un acompte est émis.",
    },
    invoice: {
      issue:
        "Attribue le numéro définitif (sans trou), fige le PDF Factur-X, puis l'envoie au comptable (Inqom ou e-mail) et à Chorus Pro pour un client public. Irréversible : on corrige par un avoir.",
      deleteDraft: "Supprime le brouillon et rend les quantités « à facturer » à la commande. Impossible après émission.",
      payment:
        "Enregistre un encaissement (montant pré-rempli avec le solde). Met à jour le payé de la facture et le statut de paiement de la commande. Un paiement peut être supprimé.",
      creditNote:
        "Prépare un avoir brouillon, total ou par lignes, à émettre ensuite. Ne remet rien en stock et ne rembourse personne : c'est un document comptable.",
      send: "Envoie le PDF émis par e-mail au client. Ne change aucun statut.",
      pdf: "Brouillon : aperçu avec filigrane. Facture émise : le PDF archivé, toujours identique. Facture Shopify : une reconstitution faite par l'ERP, jamais l'original.",
      export: "Télécharge un ZIP des PDF émis sur la période, avec un récapitulatif CSV (avoirs en négatif). Rien n'est modifié.",
      external:
        "Facture émise par Shopify (Simple Invoice) : l'ERP l'enregistre, avec son paiement, mais ne peut ni l'émettre, ni la modifier, ni l'envoyer.",
    },
    customer: {
      importShopify:
        "Lit tous les clients de la boutique. Ceux déjà connus (même id ou même e-mail) sont reliés, sans écraser ce qui a été saisi dans l'ERP ; les autres sont créés.",
      archive:
        "Masque le client des listes et des sélecteurs. Ses documents restent, et ses commandes web continuent d'arriver. Réversible.",
      history:
        "Devis et factures repris des anciens outils (IABAKO, commandes Shopify de plus de 60 jours), en lecture seule. Ils comptent dans le CA des rapports.",
    },
    shopify: {
      openOrder: "Ouvre la commande dans l'administration Shopify, dans un nouvel onglet.",
      sync: "Relit les commandes Shopify modifiées depuis la dernière synchro (aussi faite seule toutes les 15 min) : crée ou met à jour les commandes, les clients, les expéditions faites dans Shopify et, selon le mode choisi, enregistre ou émet les factures.",
      webhooks:
        "Demande à Shopify de prévenir l'ERP à chaque commande créée, payée, modifiée, annulée ou remboursée. Écrit dans la configuration de la boutique.",
      writeBack:
        "Autorise l'ERP à écrire dans Shopify : stock disponible, expéditions (avec e-mail au client), remboursements SAV et notes d'échange. Désactivé, l'ERP ne fait que lire.",
      webInvoiceMode:
        "Qui facture les commandes du site : Shopify (l'ERP enregistre seulement), l'ERP automatiquement à chaque paiement (facture numérotée, payée, envoyée au comptable), ou à la main.",
    },
    shipment: {
      ship: "Crée l'expédition et l'étiquette transporteur si demandée, sort les articles du stock et met la commande à jour. Pour une commande Shopify, seules ces lignes sont marquées expédiées et le client reçoit le suivi. Annulable tant que non livrée.",
      laposteFile:
        "Fichier à importer dans La Poste Pro Expédition pour éditer les étiquettes. Ne crée aucune expédition et ne sort rien du stock : c'est le suivi Shopify qui les enregistrera ensuite.",
      parcelLaposteFile:
        "Fichier La Poste pour ce colis (un par carton). Attention : si une étiquette Colissimo ou Chronopost existe déjà, vous en obtiendrez une seconde.",
      delivered:
        "Passe le colis « Livré » (normalement automatique par le suivi). Quand tous les colis d'une commande sont livrés, la commande l'est aussi. Irréversible.",
      tracking:
        "Enregistre le numéro de suivi. Pour une commande du site, il est envoyé à Shopify (ajouté à l'expédition si elle y existe déjà) et Shopify renvoie l'e-mail de suivi au client.",
      resend:
        "Renvoie le même contenu dans un nouveau colis (perte, casse) : les articles ressortent du stock, la commande ne change pas. Ne clôt aucun SAV.",
      serials:
        "Corrige les numéros de série partis dans ce colis : ceux retirés reviennent en stock, ceux ajoutés sortent. Ne crée aucun mouvement de stock.",
      cancel:
        "Annule une expédition non livrée : les articles reviennent en stock et la commande repasse à préparer. L'étiquette n'est pas annulée chez le transporteur. Impossible si l'expédition est déjà dans Shopify.",
      free: "Expédie des articles sans commande (échantillon, prêt, salon) : bon de livraison, étiquette, sortie de stock. Le client n'est pas relié au colis.",
    },
    stock: {
      adjust:
        "Remplace la quantité en stock par celle comptée (à la date indiquée) en écrivant la différence comme mouvement. Pour un article suivi, saisissez les numéros ajoutés ou manquants.",
      exit: "Retire du stock sans colis (casse, perte, usage interne, prêt), avec un motif obligatoire. Refusé si le stock est insuffisant. Se corrige par « Corriger le stock ».",
      count:
        "Crée un inventaire en brouillon avec tous les articles (ou une famille), à la date choisie. Rien ne change dans le stock tant qu'il n'est pas validé.",
      countValidate:
        "Écrit, à la date de l'inventaire, un mouvement par écart entre le compté et le théorique. Irréversible ; un écart se rattrape par une correction.",
      countCancel: "Abandonne l'inventaire et tout ce qui a été saisi. Le stock ne change pas.",
      serials:
        "Chaque unité porte un numéro, suivi de la réception à l'expédition. Activer le suivi demande un numéro par unité en stock ; le désactiver garde l'historique.",
      composition:
        "L'article vendu est un ensemble (gilet + cummerbund) : il n'a pas de stock propre, ce sont ses composants qui entrent et sortent.",
    },
    sav: {
      undo: "Revient sur la dernière étiquette, le dernier envoi, la dernière réception, résolution ou clôture du dossier. Les articles partis reviennent en stock, ceux reçus en ressortent. Un remboursement ne s'annule pas.",
      returnLabel:
        "Crée une étiquette retour Colissimo (PDF à transmettre au client, l'ERP ne l'envoie pas). Rien ne sort du stock ; le dossier attend le colis.",
      laposteReturn:
        "Fichier à importer dans La Poste Pro Expédition pour éditer l'étiquette retour (colis adressé à la société). Le dossier passe en attente du retour.",
      receive:
        "Enregistre les articles reçus et leur état : « Remis en stock » les fait rentrer en stock ; quarantaine et rebut restent hors stock vendable.",
      replace:
        "Envoie tout de suite les articles de remplacement (sortie de stock, bon de livraison, étiquette) sans attendre le retour, et résout le dossier.",
      exchange:
        "Envoie le nouvel article et crée l'étiquette retour de l'ancien, glissée dans le colis. Le dossier attend ensuite le retour, contrôlé à réception.",
      refund:
        "Commande Shopify : rembourse le client dans Shopify (si l'écriture est activée) et l'avoir est créé à réception du remboursement. Sinon : avoir brouillon sur la facture. Ne remet rien en stock.",
      resolve:
        "Marque le dossier résolu (réparation faite, ou sans suite) sans rien envoyer ni rembourser. Il reste à le clôturer.",
      close: "Clôture le dossier : plus aucune action possible, sauf le rouvrir.",
      reopen: "Rouvre le dossier clôturé ; il repasse « Ouvert » avec son historique.",
    },
    purchase: {
      close:
        "Termine la réception : ce qui manque n'est plus attendu en stock ni dû au fournisseur. La commande attend ensuite sa facture (« Facture à déposer ») ; déposée dans les pièces, elle part au comptable et la commande est archivée. Irréversible.",
      send: "Envoie le bon de commande PDF par e-mail au fournisseur ; une fois parti, la commande passe « Envoyée ». L'objet et le message sont en français, le PDF dans la langue du fournisseur.",
      status:
        "Change le statut sans rien envoyer : « Envoyée » date la commande, « Confirmée » note l'accord du fournisseur. Les quantités comptent alors comme « à recevoir ». Sans retour arrière.",
      edit: "Modifiable jusqu'à la clôture de la réception, sans descendre sous ce qui est déjà reçu. Rien n'est renvoyé automatiquement : pensez à renvoyer la nouvelle version au fournisseur.",
      receive:
        "Fait entrer les quantités reçues en stock, au coût converti en euros au taux saisi, et recalcule le coût moyen. Peut déposer la facture fournisseur. Irréversible.",
      payment:
        "Enregistre un acompte, un solde ou un transport versé au fournisseur, avec la banque utilisée ; le reste à payer est recalculé.",
      cancel:
        "Annule la commande : les quantités ne sont plus attendues. Le fournisseur n'est pas prévenu ; paiements et pièces restent.",
      suggestions:
        "Articles sous leur seuil, stock attendu compris. « Créer la commande » prépare un brouillon par fournisseur, rien n'est envoyé.",
      documents:
        "Les pièces déposées (factures, avoirs, tickets, contrats) sont gardées ici et transmises au comptable (Inqom ou e-mail) dès le dépôt, avec leur type.",
      creditNote: "Avoir fournisseur, facultatif : son montant est déduit du reste à payer de la commande liée.",
      transmit:
        "Envoie au comptable les pièces qui ne l'ont pas encore été (par exemple après avoir configuré Inqom). Une pièce transmise ne peut plus être supprimée.",
    },
    product: {
      importShopify:
        "Lit le catalogue de la boutique : crée les nouveaux produits et met à jour titre, famille, options, poids et prix (TTC convertis en HT). SKU, seuils, coûts et fournisseurs restent ceux de l'ERP.",
      split:
        "Crée un article par option (gilet par taille, cummerbund par taille) et transforme chaque variante du site en composition ; le stock passe sur les articles. Irréversible.",
      archive:
        "Masque le produit des listes et des sélecteurs. Le produit Shopify n'est pas touché et le stock continue d'être synchronisé. Réversible.",
      families:
        "Renommer ou fusionner change la famille de tous les produits concernés, y compris archivés ; les poids et formats de colis suivent. Une fusion ne se défait pas.",
      webLocked:
        "Titre, famille, description, options et poids viennent de Shopify et sont réécrits à chaque import du catalogue. Le prix appartient à l'ERP : modifié ici, il est envoyé à Shopify (si l'envoi des prix est activé).",
    },
    accounting: {
      chorus:
        "Factures des clients publics déposées sur Chorus Pro (Factur-X avec bon de commande et BL signé) ; le statut est relu toutes les heures. « Redéposer » renvoie une facture rejetée.",
      inqom:
        "Chaque facture émise et chaque pièce d'achat partent chez le comptable : par l'API Inqom si elle est configurée (elle remplace alors l'e-mail), sinon à l'adresse de collecte.",
      inqomSandbox:
        "En bac à sable, les pièces vont dans un dossier de test ; elles sont marquées transmises et ne repartiront pas vers le vrai dossier.",
      deposits:
        "Active les factures d'acompte : proposées à l'acceptation d'un devis et depuis la commande, puis déduites de la facture finale.",
    },
    auto: {
      jobs: "Tâches automatiques : synchro Shopify (15 min), suivi des colis (2 h), archivage des commandes, statuts Chorus et résumé des erreurs (toutes les heures), alertes de stock et contrôle d'intégrité (chaque jour).",
    },
    settings: {
      integrationTest:
        "Vérifie la connexion avec les identifiants enregistrés. Pour certains services, le test ne prouve que l'authentification, pas l'envoi réel.",
      archiveDelay:
        "Les commandes livrées ou annulées passent en « Archivées » après ce délai (vérifié toutes les heures). Elles restent consultables et restaurables.",
      userRole:
        "Changer le rôle modifie immédiatement ce que la personne peut voir et faire, et la déconnecte de tous ses appareils.",
      import:
        "« Vérifier » contrôle le fichier sans rien écrire ; « Importer » crée ou met à jour selon le mode choisi pour les doublons. Un import ne s'annule pas en bloc.",
      health:
        "Lance les contrôles de cohérence des données (stock, factures, paiements…). Ils tournent aussi chaque jour, avec un e-mail aux administrateurs en cas d'anomalie.",
      printing:
        "Un agent installé sur l'ordinateur relié à l'imprimante imprime étiquettes et bons de livraison sans clic. Hors ligne, l'ERP revient à la fenêtre d'impression du navigateur.",
    },
    statuses: {
      all: "Signification de chaque statut (commandes, factures, expéditions, SAV, achats, inventaires) et ce qui le fait changer.",
    },
  },
} as const;
